// i18n dictionary — 2 languages (Nederlands, English)
export const LANGS = [
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
];


const dict = {
  nl: {
    // Nav & app
    app_name: "Rooster", tagline: "Werkplanning voor teams die willen doorpakken.",
    login_title: "Log in op je account", login_subtitle: "Beheer je rooster, verlof en uren.",
    email: "E-mailadres", password: "Wachtwoord", login: "Inloggen", logout: "Uitloggen",
    logging_in: "Bezig met inloggen...",
    // Fase 6.5B — forced Terms/Privacy acceptance screen strings.
    // Titels wisselen op basis van de status:
    //   * eerste bezoek         → legal_title_first
    //   * alleen Voorwaarden    → legal_title_updated
    //   * alleen Privacy        → legal_title_privacy_updated
    legal_title_first: "Lees en accepteer de voorwaarden",
    legal_title_updated: "Voorwaarden bijgewerkt",
    legal_title_privacy_updated: "Privacyverklaring bijgewerkt",
    legal_title: "Lees en accepteer de voorwaarden",
    legal_intro: "Voordat je verder kunt in Rostr, willen we dat je even de laatste Voorwaarden en Privacyverklaring bekijkt en bevestigt.",
    legal_current_version: "Huidige versie",
    legal_current_terms_version: "Huidige versie Voorwaarden",
    legal_current_privacy_version: "Huidige versie Privacyverklaring",
    // Prefix + link + suffix vormen samen één zin. Nooit "instemmen met de
    // Privacyverklaring" schrijven — dat suggereert consent, wat de
    // Privacyverklaring niet is (transparantiedocument onder AVG art. 13/14).
    legal_terms_checkbox_prefix: "Ik ga akkoord met de",
    legal_terms_link: "Voorwaarden",
    legal_terms_checkbox_suffix: ".",
    legal_privacy_checkbox_prefix: "Ik bevestig dat ik de",
    legal_privacy_link: "Privacyverklaring",
    legal_privacy_checkbox_suffix: " heb kunnen lezen.",
    legal_terms_already_accepted: "Voorwaarden zijn al geaccepteerd.",
    legal_privacy_already_seen: "Privacyverklaring is al bevestigd.",
    // Legacy alias om oude tests niet te breken.
    legal_terms_checkbox: "Ik ga akkoord met de",
    legal_privacy_checkbox: "Ik bevestig dat ik de",
    legal_submit: "Bevestigen en doorgaan",
    legal_accept_success: "Bedankt voor je bevestiging.",
    legal_version_outdated: "De voorwaarden zijn ondertussen bijgewerkt. Bekijk de nieuwste versie en bevestig opnieuw.",
    legal_loading: "Even wachten…",
    legal_error: "Er ging iets mis. Probeer het opnieuw.",
    legal_logout: "Uitloggen",
    legal_version_label: "Versie",
    legal_status_error_title: "Sessiestatus niet gecontroleerd",
    legal_status_error_body: "We konden je sessiestatus niet controleren. Probeer het opnieuw.",
    legal_status_error_retry: "Opnieuw proberen",
    // Phase 8.1 — email verification gate + verify page copy.
    verify_email_title: "Controleer je e-mail",
    verify_email_check_body: "We hebben een bevestigingslink gestuurd. Klik op de knop in die e-mail om je account te activeren. De link is 24 uur geldig.",
    verify_email_resend: "Opnieuw verzenden",
    verify_email_resend_success: "We hebben een nieuwe bevestigingslink verstuurd.",
    verify_email_rate_limited: "Je hebt recent al een verificatiemail aangevraagd. Probeer het later opnieuw.",
    verify_email_resend_wait: "Wacht nog",
    verify_email_logout: "Uitloggen",
    verify_email_wrong_email_hint: "Verkeerd adres? Log uit en probeer opnieuw met het juiste account.",
    verify_email_check_again: "Ik heb bevestigd",
    verify_email_verifying: "Bezig met bevestigen...",
    verify_email_success: "Je e-mailadres is bevestigd",
    verify_email_success_body: "Bedankt! Je account is nu volledig geactiveerd. Ga verder om Rostr te gebruiken.",
    verify_email_success_body_authed: "Je e-mailadres is bevestigd. Je wordt doorgestuurd naar Rostr…",
    verify_email_success_body_unauth: "Je e-mailadres is bevestigd.",
    verify_email_redirecting: "Bezig met doorsturen…",
    verify_email_continue_to_rostr: "Ga naar Rostr",
    verify_email_continue: "Doorgaan naar Rostr",
    verify_email_invalid: "Link ongeldig of verlopen",
    verify_email_invalid_body: "Deze bevestigingslink werkt niet meer. Vraag een nieuwe aan vanuit je Rostr-account.",
    verify_email_back_to_resend: "Terug naar Rostr",
    verify_email_back_to_login: "Naar inloggen",
    verify_email_status_verified: "E-mailadres bevestigd",
    verify_email_status_unverified: "E-mailadres nog niet bevestigd",
    email_verification_required: "Bevestig eerst je e-mailadres om verder te gaan.",
    // Phase 8.2 — Security section + MFA copy.
    security_title: "Beveiliging",
    security_email_label: "E-mailadres",
    security_email_verified: "Bevestigd",
    security_email_unverified: "Niet bevestigd",
    security_mfa_label: "Twee-stapsverificatie",
    security_mfa_on: "Ingeschakeld",
    security_mfa_off: "Uitgeschakeld",
    security_mfa_desc_on: "Elke login vraagt om een 6-cijferige code uit je authenticator-app.",
    security_mfa_desc_off: "Voeg een extra beveiligingslaag toe met een authenticator-app.",
    security_enable_mfa: "Inschakelen",
    security_disable_mfa: "Uitschakelen",
    security_regenerate_recovery: "Herstelcodes vernieuwen",
    mfa_enable_title: "Twee-stapsverificatie inschakelen",
    mfa_enable_password_prompt: "Bevestig eerst je wachtwoord om verder te gaan.",
    mfa_scan_title: "Scan de QR-code",
    mfa_scan_subtitle: "Open je authenticator-app (Google Authenticator, 1Password, Authy...) en scan de QR-code. Kun je niet scannen? Voer de code hieronder handmatig in.",
    mfa_scan_manual_key: "Handmatige sleutel",
    mfa_verify_title: "Bevestig met je 6-cijferige code",
    mfa_verify_subtitle: "Voer de code in die je authenticator-app nu toont.",
    mfa_enable_confirm: "Inschakelen",
    mfa_recovery_title: "Bewaar je herstelcodes",
    mfa_recovery_subtitle_new: "Deze codes zie je maar één keer. Bewaar ze op een veilige plek — je hebt ze nodig als je je telefoon kwijtraakt.",
    mfa_recovery_subtitle_regen: "Je oude herstelcodes werken niet meer. Bewaar deze nieuwe codes veilig.",
    mfa_recovery_done: "Ik heb ze bewaard",
    mfa_recovery_warning: "Elke code werkt maar één keer.",
    mfa_disable_description: "Bevestig je wachtwoord om twee-stapsverificatie uit te schakelen.",
    mfa_disable_success: "Twee-stapsverificatie is uitgeschakeld.",
    mfa_regenerate_description: "Bevestig je wachtwoord om een nieuwe set herstelcodes aan te maken. Je oude codes werken direct niet meer.",
    mfa_password_wrong: "Wachtwoord onjuist.",
    mfa_code_wrong: "Code klopt niet. Probeer opnieuw.",
    // Login MFA challenge screen
    login_mfa_title: "Twee-stapsverificatie",
    login_mfa_subtitle: "Voer de 6-cijferige code in die je authenticator-app toont.",
    login_mfa_placeholder: "123456",
    login_mfa_submit: "Verifiëren",
    login_mfa_use_recovery: "Herstelcode gebruiken",
    login_mfa_use_totp: "Terug naar code",
    login_mfa_recovery_placeholder: "XXXXX-XXXXX",
    login_mfa_error: "Verificatie mislukt. Probeer opnieuw.",
    login_mfa_rate_limited: "Te veel pogingen. Probeer het over een paar minuten opnieuw.",
    // Small shared
    copy_all: "Kopieer alles",
    copied: "Gekopieerd",
    download_txt: "Download .txt",
    back: "Terug",
    continue: "Doorgaan",
    cancel: "Annuleren",
    password: "Wachtwoord",
    error: "Er ging iets mis. Probeer opnieuw.",
    welcome_good_morning: "Goedemorgen",
    welcome_good_afternoon: "Goedemiddag",
    welcome_good_evening: "Goedenavond",
    welcome_back_name: "Welkom terug, {firstName}",
    welcome_back_generic: "Welkom terug",
    welcome_summary_intro: "Dit vraagt nu je aandacht.",
    welcome_first_use_intro: "Dit vraagt nu je aandacht.",
    welcome_since_last_visit_intro: "Dit is er veranderd sinds je vorige bezoek.",
    welcome_view_summary: "Bekijk overzicht",
    welcome_skip_now: "Nu overslaan",
    welcome_close: "Sluiten",
    welcome_missed_title: "Wat heb je gemist?",
    welcome_missed_subtitle: "Dit is er veranderd sinds je laatste bezoek.",
    welcome_first_use_title: "Dit staat er nog op je bordje.",
    welcome_first_use_subtitle: "Hier is wat nu je aandacht nodig heeft.",
    welcome_all_caught_up: "Je bent helemaal bij.",
    welcome_no_updates: "Er zijn geen belangrijke nieuwe updates sinds je laatste bezoek.",
    welcome_go_to_rostr: "Naar Rostr",
    welcome_back_button: "Terug",
    welcome_step_of: "{a} van {b}",
    welcome_group_new: "Nieuw sinds je vorige bezoek",
    welcome_group_outstanding: "Nog openstaand",
    welcome_unread_notifications: "{n} ongelezen meldingen",
    welcome_pending_leave: "{n} openstaande verlofaanvragen",
    welcome_pending_swaps: "{n} openstaande ruilverzoeken",
    welcome_pending_time: "{n} uren-goedkeuringen te beoordelen",
    welcome_open_shifts: "{n} open diensten",
    welcome_shifts_this_week: "{n} diensten deze week",
    welcome_my_shifts_today: "{n} eigen dienst(en) vandaag",
    welcome_my_shifts_week: "{n} eigen diensten deze week",
    welcome_pending_own_leave: "{n} eigen verlofaanvragen wachten",
    welcome_claimable_shifts: "{n} claimbare diensten",
    welcome_new_notifications: "{n} nieuwe meldingen",
    welcome_new_leave_requests: "{n} nieuwe verlofaanvragen",
    welcome_new_swap_requests: "{n} nieuwe ruilverzoeken",
    welcome_new_time_submissions: "{n} nieuwe uren-inzendingen",
    welcome_new_open_shifts: "{n} nieuwe open diensten",
    welcome_new_own_leave_decided: "{n} beslissingen op je verlofaanvragen",
    welcome_new_swap_offers: "{n} nieuwe ruilverzoeken voor jou",
    welcome_new_my_shifts: "{n} nieuwe diensten voor jou",
    settings_welcome_summary_label: "Welkomstoverzicht na inloggen",
    settings_welcome_summary_description: "Toon na het inloggen een korte begroeting en een overzicht van wat je hebt gemist. Deze voorkeur is persoonlijk en geldt alleen voor jou.",
    // Fase 6.5C — friendly translated copy for CSRF failures. Never mention
    // "CSRF" to end users; frame as a stale secure session.
    csrf_invalid_toast: "Je beveiligde sessie kon niet worden geverifieerd. Vernieuw de pagina en probeer opnieuw.", demo_accounts: "Demo accounts", forgot_password: "Wachtwoord vergeten?",
    dashboard: "Dashboard", roster: "Rooster", employees: "Medewerkers", locations: "Locaties",
    teams: "Teams", leave_requests: "Verlofaanvragen", swap_requests: "Dienstwissels",
    time_approvals: "Uren goedkeuren", notifications: "Meldingen", news: "Nieuws",
    my_roster: "Mijn rooster", my_leave: "Mijn verlof", my_availability: "Beschikbaarheid",
    // Phase 9B.3a — Employee mobile agenda kick-off
    next_shift_eyebrow: "Volgende dienst",
    next_shift_today_eyebrow: "Vandaag",
    my_swaps: "Mijn ruilverzoeken", profile: "Profiel", settings: "Instellingen",
    new: "Nieuw", save: "Opslaan", cancel: "Annuleren", delete: "Verwijderen", edit: "Bewerken",
    approve: "Goedkeuren", reject: "Afwijzen", accept: "Accepteren", decline: "Afwijzen",
    publish: "Publiceren", publish_week: "Week publiceren", open_shifts: "Open diensten",
    total_employees: "Medewerkers", open_shifts_stat: "Openstaande diensten",
    pending_leave: "Verlof in behandeling", pending_swaps: "Ruilverzoeken",
    pending_time: "Uren te controleren", shifts_this_week: "Diensten deze week",
    today: "Vandaag", week: "Week", day: "Dag", prev: "Vorige", next: "Volgende",
    from: "Van", to: "Tot", date: "Datum", start: "Starttijd", end: "Eindtijd",
    role: "Rol", role_label: "Functie/rol", location: "Locatie", team: "Team",
    employee: "Medewerker", unassigned: "Onbezet", status: "Status",
    draft: "Concept", published: "Gepubliceerd", pending: "In behandeling",
    approved: "Goedgekeurd", rejected: "Afgewezen", accepted: "Geaccepteerd",
    declined: "Afgewezen", cancelled: "Geannuleerd",
    add_employee: "Medewerker toevoegen", add_location: "Locatie toevoegen",
    add_team: "Team toevoegen", add_shift: "Dienst toevoegen",
    request_leave: "Verlof aanvragen", request_swap: "Ruilen aanvragen",
    submit_hours: "Uren indienen",
    reason: "Reden", manager_note: "Notitie van manager", message: "Bericht",
    name: "Naam", phone: "Telefoon", language: "Taal", address: "Adres", city: "Plaats",
    color: "Kleur", description: "Omschrijving", mark_all_read: "Alles gelezen markeren",
    landing_eyebrow: "Werkplanning voor teams",
    demo_hint: "klik om in te vullen",
    no_data: "Nog geen gegevens.", saved: "Opgeslagen", error: "Er ging iets mis",
    hours_col: "Uren", hours_this_week: "deze week",
    hvc_badge_on: "op contract", hvc_badge_over: "boven contract", hvc_badge_under: "onder contract",
    ok_leave_submitted: "Verlof aangevraagd",
    ok_swap_submitted: "Ruilverzoek verzonden",
    ok_profile_saved: "Profiel opgeslagen",
    ok_permissions_saved: "Rechten opgeslagen",
    confirm_delete: "Weet je zeker dat je dit wilt verwijderen?",
    confirm_delete_title: "Weet je het zeker?",
    confirm_delete_loc_body: "Locatie \"{name}\" wordt permanent verwijderd. Diensten en teams die aan deze locatie zijn gekoppeld verliezen die referentie. Dit kan niet ongedaan worden.",
    confirm_delete_team: "Team \"{name}\" wordt verwijderd. Bestaande diensten met dit team blijven bestaan maar verliezen de team-koppeling.",
    confirm_delete_employee: "Medewerker \"{name}\" wordt verwijderd. Hun account wordt gedeactiveerd en toekomstige diensten worden onbezet.",
    confirm_delete_document: "Document \"{title}\" wordt permanent verwijderd. Dit kan niet ongedaan worden.",
    confirm_delete_shift: "Deze dienst wordt verwijderd. Je hebt 5 seconden om het ongedaan te maken.",
    undo: "Ongedaan maken",
    copied: "Gekopieerd",
    shift_deleted: "Dienst verwijderd",
    team_deleted: "Team verwijderd",
    employee_deleted: "Medewerker verwijderd",
    document_deleted: "Document verwijderd",
    ical_export: "Export naar Kalender (.ics)",
    ical_downloaded: "Rooster gedownload",
    invite_modal_eyebrow: "Uitnodiging",
    invite_modal_title: "Deel deze code met je collega",
    invite_modal_role: "Rol",
    invite_code_label: "6-letter code",
    invite_scan_hint: "Scan met de camera",
    invite_scan_desc: "Nieuwe collega scant deze QR-code met zijn telefoon om direct de join-pagina te openen.",
    invite_copy_url: "Kopieer link",
    invite_share: "Delen",
    invite_share_title: "Word lid van ons rooster",
    invite_share_text: "Gebruik code {code} om lid te worden van ons team op Rostr.",
    open_to_anyone: "Open aan iedereen",
    // Documents page — Phase 7.2 storage-backed module.
    docs_page_title: "Documenten",
    docs_subtitle_mgmt: "Beheer beleid, protocollen en interne documenten.",
    docs_subtitle_employee: "Bekijk de documenten die voor jou beschikbaar zijn.",
    docs_new_document: "Nieuw document",
    docs_new_version: "Nieuwe versie uploaden",
    docs_search_placeholder: "Zoek op titel...",
    docs_filter_category: "Categorie",
    docs_filter_status: "Status",
    docs_filter_visibility: "Zichtbaarheid",
    docs_filter_ack: "Bevestiging",
    docs_filter_all: "Alle",
    docs_filter_action_required: "Actie vereist",
    docs_filter_ack_yes: "Bevestiging vereist",
    docs_filter_ack_no: "Geen bevestiging",
    docs_cat_policy: "Beleid",
    docs_cat_safety: "Veiligheid",
    docs_cat_procedure: "Procedure",
    docs_cat_handbook: "Handboek",
    docs_cat_hr: "HR",
    docs_cat_employee_document: "Medewerker-document",
    docs_cat_other: "Overig",
    docs_status_draft: "Concept",
    docs_status_published: "Gepubliceerd",
    docs_status_archived: "Gearchiveerd",
    docs_status_superseded: "Vervangen",
    docs_status_current: "Huidige versie",
    docs_vis_company: "Hele organisatie",
    docs_vis_location: "Locatie",
    docs_vis_team: "Team",
    docs_vis_selected_users: "Geselecteerde medewerkers",
    docs_vis_employee_private: "Persoonlijk medewerkersdocument",
    docs_col_document: "Document",
    docs_col_category: "Categorie",
    docs_col_version: "Versie",
    docs_col_visibility: "Zichtbaarheid",
    docs_col_updated: "Bijgewerkt",
    docs_col_status: "Status",
    docs_col_actions: "Acties",
    docs_upload_choose_file: "Kies een bestand",
    docs_upload_selected_file: "Geselecteerd bestand",
    docs_upload_title_field: "Titel",
    docs_upload_desc_field: "Beschrijving",
    docs_upload_desc_optional: "Optioneel",
    docs_upload_category_field: "Categorie",
    docs_upload_visibility_field: "Zichtbaarheid",
    docs_upload_require_ack: "Bevestiging vereist",
    docs_upload_pick_location: "Kies één of meer locaties",
    docs_upload_pick_team: "Kies één of meer teams",
    docs_upload_pick_users: "Kies één of meer medewerkers",
    docs_upload_pick_subject: "Kies medewerker",
    docs_upload_max_size: "Maximaal {n} MB per bestand.",
    docs_upload_supported_types: "PDF, DOCX, XLSX, PNG, JPG, TXT, CSV.",
    docs_upload_uploading: "Uploaden...",
    docs_upload_save_draft: "Opslaan als concept",
    docs_upload_publish_now: "Publiceren",
    docs_upload_saved_draft: "Concept opgeslagen.",
    docs_upload_version_saved: "Versie {n} is als concept opgeslagen.",
    docs_upload_error_type: "Bestandstype niet toegestaan.",
    docs_upload_error_too_large: "Bestand is te groot (max {n} MB).",
    docs_upload_error_generic: "Uploaden mislukt.",
    docs_publish_confirm_title: "Versie publiceren?",
    docs_publish_confirm_body: "Deze versie wordt zichtbaar voor medewerkers.",
    docs_publish_confirm_reack: "Medewerkers voor wie dit document zichtbaar is moeten deze versie opnieuw bevestigen.",
    docs_publish_success: "Versie gepubliceerd.",
    docs_publish_failed: "Publiceren mislukt.",
    docs_archive_confirm_title: "Document archiveren?",
    docs_archive_confirm_body: "Dit document wordt niet meer aan medewerkers getoond.",
    docs_archived_success: "Gearchiveerd.",
    docs_delete_confirm_title: "Document permanent verwijderen?",
    docs_delete_confirm_body: "Alle versies en bevestigingen van dit document worden permanent verwijderd.",
    docs_delete_confirm_typed: "Typ de titel om te bevestigen:",
    docs_delete_success: "Document verwijderd.",
    docs_delete_failed: "Verwijderen mislukt. Probeer het opnieuw.",
    docs_delete_owner_only: "Alleen de eigenaar kan permanent verwijderen.",
    docs_download: "Downloaden",
    docs_downloading: "Bezig met openen...",
    docs_download_failed: "Kon bestand niet openen.",
    docs_ack_button: "Ik heb dit document gelezen",
    docs_ack_confirm_title: "Bevestigen",
    docs_ack_confirm_body: "Ik bevestig dat ik dit document heb gelezen.",
    docs_ack_success: "Bevestigd.",
    docs_ack_already: "Je hebt deze versie al bevestigd.",
    docs_acked_status: "Bevestigd",
    docs_ack_matrix_title: "Bevestigingen",
    docs_ack_matrix_summary: "{done} van {total} bevestigd",
    docs_ack_matrix_none: "Nog niemand heeft deze versie bevestigd.",
    docs_ack_matrix_pending_none: "Iedereen heeft deze versie bevestigd.",
    docs_ack_pending: "Nog niet bevestigd",
    docs_ack_at: "Bevestigd op",
    docs_versions_title: "Versiegeschiedenis",
    docs_version_label: "Versie {n}",
    docs_versions_empty: "Nog geen versies. Upload het eerste bestand om te beginnen.",
    docs_meta_created: "Aangemaakt",
    docs_meta_updated: "Bijgewerkt",
    docs_meta_uploaded_by: "Geüpload door",
    docs_meta_file_size: "Bestandsgrootte",
    docs_meta_content_type: "Bestandstype",
    docs_meta_current_version: "Huidige versie",
    docs_meta_latest_version: "Laatst geüpload",
    docs_meta_never_published: "Nog niet gepubliceerd",
    docs_meta_no_current: "Nog geen gepubliceerde versie",
    docs_empty_owner_title: "Nog geen documenten",
    docs_empty_owner_body: "Upload een beleid, protocol of ander intern document om te beginnen.",
    docs_empty_employee_title: "Geen documenten beschikbaar",
    docs_empty_employee_body: "Er zijn momenteel geen documenten voor jou.",
    docs_empty_action_required: "Je bent helemaal bij.",
    docs_section_action_required: "Actie vereist",
    docs_section_available: "Beschikbaar voor jou",
    docs_section_personal: "Persoonlijke documenten",
    docs_disabled_title: "Documenten zijn niet beschikbaar",
    docs_disabled_body: "Deze module is nog niet ingeschakeld voor je organisatie.",
    docs_storage_unavailable_title: "Documenten zijn tijdelijk niet beschikbaar",
    docs_storage_unavailable_body: "Probeer het later opnieuw.",
    docs_forbidden: "Geen toegang tot dit document.",
    docs_not_found: "Document niet gevonden.",
    docs_close: "Sluiten",
    docs_open_detail: "Openen",
    docs_toolbar_reset: "Filters wissen",
    docs_visibility_summary: "Zichtbaar voor: {who}",
    docs_by_uploader: "door {name}",
    // Welcome integration.
    welcome_documents_pending_ack: "{n} openstaande documentbevestigingen",
    welcome_new_documents_published: "{n} nieuw gepubliceerde documenten",
    // Notification copy.
    notif_document_ack_required_title: "Nieuw document vereist je aandacht.",
    notif_document_ack_required_body: "Er staat een nieuw document voor je klaar.",
    search_placeholder: "Zoeken...",
    emp_search_placeholder: "Zoek op naam, functie of afdeling…",
    invite_code_action: "Uitnodigingscode",
    invite_short: "Uitnodigen",
    // Playful empty states — replaces bare "geen data" walls with hopeful copy.
    empty_roster_title: "Nog een lege dag ✈️",
    empty_roster_hint: "Tik op de + knop om je eerste dienst voor deze dag toe te voegen.",
    empty_notifs_title: "Alles rustig hier ✨",
    empty_notifs_hint: "Nieuwe meldingen landen vanzelf in je scherm.",
    empty_news_title: "Nog geen nieuws om te delen",
    empty_news_hint: "Wees de eerste die iets deelt met het team — een tip, een succes of gewoon een goedemorgen.",
    empty_leaves_title: "Geen verlofaanvragen",
    empty_leaves_hint: "Als iemand vrij vraagt zie je het hier meteen verschijnen.",
    empty_swaps_title: "Geen open ruilverzoeken",
    empty_swaps_hint: "Ruil kan je pas verlangen als je een dienst hebt om te ruilen. Kom later terug.",
    empty_timesheets_title: "Alle uren zijn afgehandeld",
    empty_timesheets_hint: "Zodra iemand uren klokt komen ze hier te controleren.",
    empty_search_title: "Niets gevonden",
    empty_search_hint: "Probeer een andere zoekterm of pas de filters aan.",
    empty_generic_title: "Hier is het nog leeg",
    empty_generic_hint: "Voeg iets toe om te beginnen, of kom later terug.",
    clear_search: "Zoekopdracht wissen",
    // Pauze-instellingen extras
    enabled_label: "Ingeschakeld",
    disabled_label: "Uitgeschakeld — pauzes worden handmatig ingevuld",
    pause_mode_title: "Rekenmethode",
    pause_mode_hint: "Kies hoe Rostr de pauze bepaalt.",
    pause_config_title: "Regels instellen",
    pause_config_hint_flat: "Diensten vanaf de drempel krijgen automatisch een vaste pauze.",
    pause_config_hint_tiered: "Voeg trappen toe: langere dienst = langere pauze.",
    pause_warning_title: "Waarschuwing bij lage pauze",
    pause_warning_hint: "Krijg een waarschuwing als de ingevulde pauze te kort lijkt voor de dienstduur.",
    pause_preview_title: "Live voorbeeld",
    pause_preview_desc: "Zo rekent Rostr de pauze uit met jouw huidige instellingen.",
    hours_short: "u",
    minutes_short: "min",
    no_pause: "geen pauze",
    high_short: "Hoog",
    // News / birthday
    news_hide: "Verbergen",
    bday_toast_sent: "🎉 Felicitatie verstuurd",
    bday_toast_error: "Kon niet feliciteren",
    bday_celebrate: "Feliciteer",
    bday_celebrated: "Gefeliciteerd",
    // Trash bin (soft-deleted employees)
    trash_eyebrow: "Herstel",
    trash_title: "Prullenbak",
    trash_subtitle: "Verwijderde medewerkers blijven hier. Herstel ze binnen 30 dagen of verwijder definitief.",
    trash_open: "Prullenbak",
    trash_restore: "Herstellen",
    trash_purge: "Definitief verwijderen",
    trash_restored: "Medewerker hersteld",
    trash_purged: "Definitief verwijderd",
    trash_deleted_at: "verwijderd op",
    trash_empty_title: "Prullenbak is leeg",
    trash_empty_hint: "Verwijderde medewerkers verschijnen hier zodat je ze kunt herstellen.",
    trash_confirm_title: "Definitief verwijderen?",
    trash_confirm_body: "Medewerker \"{name}\" wordt onherstelbaar verwijderd inclusief e-mail en alle instellingen. Dit kan niet ongedaan worden.",
    // iCal subscribe
    ical_subscribe: "Auto-sync (webcal)",
    ical_subscribe_title: "Rooster live in je kalender",
    ical_subscribe_desc: "Kopieer de webcal-link en voeg hem toe aan Google Calendar, Apple Calendar of Outlook. Elk uur worden je nieuwe diensten automatisch ingeladen.",
    ical_subscribe_copy: "Kopieer webcal-link",
    ical_url_copied: "Link gekopieerd — plak in je kalender-app",
    ical_generating: "Link maken…",
    ical_revoke: "Sync uitschakelen",
    ical_revoked: "Sync uitgeschakeld",
    ical_help_google: "Google Calendar → + naast 'Andere agenda's' → Via URL",
    ical_help_apple: "Apple Calendar → Bestand → Nieuwe agenda-abonnement",
    // What's new drawer
    wn_eyebrow: "Nieuw",
    wn_title: "Wat is er nieuw in Rostr?",
    wn_got_it: "Ga aan de slag",
    wn_auto_pause_title: "Auto-pauze op basis van regels",
    wn_auto_pause_desc: "Stel je pauze-regels 1x in bij Instellingen → Pauze en Rostr rekent het voor elke dienst automatisch uit.",
    wn_dnd_title: "Sleep diensten in de matrix",
    wn_dnd_desc: "Wijs shifts snel opnieuw toe door ze in de matrix-view te slepen naar een andere medewerker.",
    wn_mobile_roster_title: "Rooster op je telefoon",
    wn_mobile_roster_desc: "Managers en teamleiders openen nu het rooster per dag onderweg.",
    wn_widget_popup_title: "Widget-details op één plek",
    wn_widget_popup_desc: "Klik op elk dashboard-widget om details + snelle acties te zien.",
    // Onboarding checklist
    ocl_eyebrow: "Aan de slag",
    ocl_title: "Rond je setup af in 5 stappen",
    ocl_progress: "{done} van {total} klaar",
    ocl_dismiss: "Later",
    ocl_step_location: "Voeg een locatie toe",
    ocl_step_team: "Maak je eerste team",
    ocl_step_employees: "Nodig medewerkers uit",
    ocl_step_shift: "Plan je eerste dienst",
    ocl_step_publish: "Publiceer je eerste week",
    role_owner: "Eigenaar", role_manager: "Manager", 
    role_teamlead: "Teamleider", role_employee: "Medewerker",
    role_perm_owner: "Alle rechten",
    role_perm_manager: "Geen locaties/billing",
    role_perm_teamlead: "Rooster & verlof",
    role_perm_employee: "Eigen rooster",
    managed_locations_label: "Locaties die deze manager beheert",
    managed_locations_hint: "Selecteer één of meerdere locaties. Deze manager ziet en beheert alleen rooster, medewerkers, teams en diensten binnen deze locaties.",
    managed_locations_all_selected: "Geen selectie = toegang tot alle locaties",
    managed_locations_x_selected: "{n} locatie(s) geselecteerd — toegang beperkt tot deze locaties",
    managed_locations_none_yet: "Maak eerst locaties aan om ze aan een manager te kunnen koppelen.",
    // "Nieuw" badge in de zijbalk voor het handboek
    nav_new_badge: "NIEUW",
    // Relatieve tijd voor ruilverzoeken en overige lijsten
    time_just_now: "zojuist",
    time_minutes_ago: "{n} min geleden",
    time_hours_ago: "{n} uur geleden",
    time_yesterday: "gisteren",
    time_days_ago: "{n} dagen geleden",
    time_one_week_ago: "1 week geleden",
    time_weeks_ago: "{n} weken geleden",
    time_months_ago: "{n} maanden geleden",
    swap_requested_prefix: "Aangevraagd {ago}",
    // Team-samenstelling widget
    w_team_composition: "Team-samenstelling",
    w_team_composition_desc: "Verdeling van rollen in je bedrijf",
    team_composition_total: "medewerkers",
    // Locaties: managers per locatie
    loc_managers_label: "Managers op deze locatie",
    loc_managers_none: "Nog niemand toegewezen. Ga naar Medewerkers → bewerk een manager om deze locatie te koppelen.",
    loc_managers_unscoped_tag: "alle locaties",
    loc_managers_unscoped_hint: "Deze manager beheert alle locaties (geen scope ingesteld).",
    loc_managers_more_tooltip: "En nog meer managers",
    // Avatar upload
    avatar_label: "Profielfoto",
    avatar_upload: "Foto uploaden",
    avatar_replace: "Foto vervangen",
    avatar_remove: "Verwijder foto",
    avatar_saved: "Foto opgeslagen",
    avatar_removed: "Foto verwijderd",
    avatar_hint: "Vierkant werkt het best · max 8 MB",
    avatar_err_type: "Alleen afbeeldingen zijn toegestaan",
    avatar_err_size: "Afbeelding is te groot (max 8 MB)",
    emp_no_name: "Naamloos",
    emp_section_personal: "Persoonlijk",
    emp_section_role: "Rol & toewijzing",
    emp_section_scope: "Beheer-scope",
    role_hr: "HR",
    loc_focus_hint: "Klik om alleen deze locatie te tonen in de hele app",
    loc_focus_activated: "Focus op locatie '{name}' geactiveerd",
    loc_scope_banner: "Actieve locatie: {name}. Alle lijsten filteren op deze locatie.",
    loc_scope_clear: "Alle locaties tonen",
    loc_scope_cleared: "Locatie-filter uitgezet",
    // Location scope UI — banner + dropdown + Locations page (Feb 2026 refresh)
    loc_scope_pill_all: "Alle locaties",
    loc_scope_pill_one: "Locatie: {name}",
    loc_scope_switcher_label: "Wissel snel van locatie",
    loc_scope_switcher_all: "Alle locaties tonen",
    loc_scope_reloading: "Data van {name} laden…",
    loc_scope_reloading_all: "Alle locaties laden…",
    loc_page_intro_title: "Zo werkt locatie-focus",
    loc_page_intro_body: "Kies een locatie om het hele dashboard, alle roosters, medewerkerslijsten, teams en rapporten alleen die locatie te laten tonen. Wissel op elk moment via de blauwe balk bovenaan.",
    loc_page_intro_active: "Je bekijkt nu alleen data van {name}.",
    loc_page_intro_all: "Je bekijkt momenteel data van alle locaties.",
    loc_view_this: "Bekijk deze locatie",
    loc_active_here: "Nu actief",
    loc_stat_employees: "medewerkers",
    loc_stat_teams: "teams",
    payroll_edit_short: "Tarief",
    payroll_actions_col: "Acties",
    // Shift editor modal — redesigned Feb 2026
    shift_preview_label: "Voorbeeld",
    shift_date_missing: "Kies een datum",
    shift_unassigned_label: "Nog niet toegewezen",
    shift_section_when: "Wanneer",
    shift_section_who: "Wie",
    shift_section_who_hint: "Selecteer een medewerker, of laat open zodat iemand de dienst kan claimen.",
    shift_section_where: "Waar",
    shift_section_where_hint: "Locatie en (optioneel) team waar deze dienst plaatsvindt.",
    shift_section_details: "Details",
    shift_section_details_hint: "Functie, pauze en notities. Optioneel.",
    shift_section_status: "Publicatie",
    shift_section_status_hint: "Publiceer wanneer je klaar bent — anders blijft de dienst als concept staan.",
    shift_save_cta: "Dienst opslaan",
    shift_publish_cta: "Dienst publiceren",
    shift_pause: "Pauze (min)",
    shift_pause_hint: "Leeg = automatisch berekend uit instellingen",
    shift_pause_auto: "auto",
    shift_team_loc_mismatch: "Dit team hoort niet bij de gekozen locatie.",
    shift_presets_label: "Snel invullen:",
    shift_preset_morning: "Ochtend",
    shift_preset_afternoon: "Middag",
    shift_preset_evening: "Avond",
    shift_preset_fullday: "Volle dag",
    // Phase 9B.3b1b — SideDrawer editor + sticky publish bar
    shift_save_add_another: "Opslaan & nog een",
    shift_save_add_another_hint: "Bewaar deze dienst en houd de drawer open om er nog een toe te voegen.",
    shift_conflict_preview_title: "Overlap gedetecteerd",
    unpublished_changes: "niet-gepubliceerde wijzigingen",
    unpublished_single: "niet-gepubliceerde wijziging",
    unpublished_state: "niet-gepubliceerd",
    open_shift_single: "open dienst",
    open_needs_one: "wacht op invulling",
    open_needs_many: "wachten op invulling",
    on_leave_short: "Afwezig",
    unavailable_short: "Niet beschikbaar",
    assign_hint: "Wijs een medewerker toe",
    empty_day: "leeg",
    scheduled_single: "ingepland",
    scheduled_many: "ingepland",
    scheduled_short: "ingepland",
    conflict_short: "conflict",
    wijz_short: "wijz.",
    employee_single: "medewerker",
    employee_many: "medewerkers",
    open_needed_single: "nodig",
    open_needed_many: "nodig",
    day_agenda_empty_title: "Nog geen diensten gepland voor deze dag.",
    day_agenda_empty_hint: "Klik op ‘Dienst toevoegen’ of tik op een tijdstip in de balk om te beginnen.",
    shift_show_more: "Meer opties",
    shift_hide_more: "Minder opties",
    shift_publish_now: "Direct publiceren (medewerkers zien deze dienst)",
    more: "Meer",
    filters_active: "Actief filter",
    clear_filter: "Filter wissen",
    employee_picker_search: "Zoek medewerker…",
    employee_picker_no_results: "Geen medewerker gevonden.",
    employee_selected: "Gekozen",
    open_shift_label: "Open dienst (geen medewerker)",
    overlap: "Overlap",
    publish_up_to_date_hint: "Alle wijzigingen zijn al gepubliceerd.",
    status_fully_planned: "Volledig ingepland",
    view_calendar: "Kalender",
    view_employee: "Medewerkers",
    view_day: "Dagen",
    open_shift_badge: "OPEN",
    employees_plural: "medewerkers",
    shift_single: "dienst",
    shifts_plural: "diensten",
    sticky_publish_hint: "Medewerkers zien nog het eerder gepubliceerde rooster.",
    // Phase 9B.3b2 — publish confirmation + extended validate-preview
    publish_confirm_title: "Rooster publiceren?",
    publish_confirm_body: "Na publiceren zien alle betrokken medewerkers dit rooster direct. Concept-diensten worden zichtbaar en eventuele wijzigingen op reeds gepubliceerde diensten worden bijgewerkt.",
    publish_failed: "Publiceren mislukt. Je concept blijft bewaard — probeer het opnieuw.",
    shift_preview_warnings_title: "Let op",
    shift_preview_on_leave: "Medewerker heeft goedgekeurd verlof",
    shift_preview_unavailable: "Medewerker heeft aangegeven niet beschikbaar te zijn",
    // Permissions-pagina
    permissions_nav: "Bevoegdheden",
    permissions_eyebrow: "Beheer",
    permissions_title: "Bevoegdheden & toewijzingen",
    permissions_subtitle: "Bepaal per teamleider welke medewerkers ze aansturen en welke acties ze mogen uitvoeren.",
    permissions_empty_title: "Nog geen teamleiders",
    permissions_empty_hint: "Maak eerst een teamleider aan bij Medewerkers om hier bevoegdheden te kunnen instellen.",
    perm_managed_employees_label: "Beheert deze medewerkers",
    perm_permissions_label: "Bevoegdheden",
    perm_all_employees: "Alle medewerkers",
    perm_all_employees_hint: "Deze teamleider ziet en beheert alle medewerkers binnen zijn/haar locatie-scope.",
    perm_x_selected: "{n} medewerker(s) geselecteerd — toegang beperkt tot deze personen.",
    perm_no_employees_yet: "Nog geen medewerkers aangemaakt.",
    perm_view_documents: "Documenten inzien",
    perm_approve_leave: "Verlof goedkeuren",
    perm_approve_swaps: "Ruilverzoeken goedkeuren",
    perm_edit_shifts: "Rooster aanpassen",
    perm_view_reports: "Rapporten inzien",
    shift_single: "dienst",
    shifts_plural: "diensten",
    day_empty: "Vrij",
    all_short: "Alle",
    draft_short: "Concept",
    shift_section_templates: "Sjabloon",
    shift_section_templates_hint: "Kies een opgeslagen preset of maak deze dienst het startpunt voor een nieuwe.",
    shift_template_choose: "Kies sjabloon…",
    shift_template_save: "Sla op als sjabloon",
    shift_template_save_hint: "Bewaar de huidige tijden, locatie en functie voor volgende keer",
    shift_template_delete: "Verwijder sjabloon…",
    shift_template_saved: "Sjabloon opgeslagen",
    shift_template_prompt_name: "Naam van sjabloon (bv. 'Weekend keuken 08–16'):",
    shift_template_applied: "Sjabloon '{name}' toegepast",
    shift_template_delete_confirm: "Sjabloon '{name}' verwijderen?",
    seat_banner_used: "medewerkers gebruikt",
    seat_banner_ok: "Er is nog volop ruimte op je huidige plan.",
    seat_banner_nearly_full: "Bijna vol",
    seat_banner_full_title: "Je plan zit vol",
    seat_banner_full_hint: "Alleen de eigenaar kan upgraden of extra plekken toevoegen.",
    seat_banner_full_owner: "Upgrade naar Pro voor onbeperkte medewerkers.",
    seat_banner_slot_one: "plek over",
    seat_banner_slot_many: "plekken over",
    seat_upgrade_cta: "Upgrade",
    seat_modal_title: "Meer medewerkers? Upgrade je plan.",
    seat_modal_body_generic: "Je huidige plan heeft een maximum aantal medewerkers bereikt (incl. openstaande uitnodigingen). Upgrade naar Pro voor onbeperkt.",
    seat_modal_upgrade_hint: "Kies Pro voor onbeperkte medewerkers en alle functies.",
    seat_modal_go_billing: "Naar abonnement",
    documents_label: "Documenten",
    repeat_label: "Herhalen",
    repeat_weekly: "Herhaal wekelijks",
    repeat_hint: "Maakt kopieën van deze dienst op dezelfde weekdag.",
    weeks_short: "weken",
    // Auto-pause
    pause_label: "Pauze",
    pause_minutes_short: "min pauze",
    auto_label: "auto",
    pause_settings: "Pauze-instellingen",
    pause_nav_label: "Pauze",
    widget_detail_eyebrow: "Widget",
    widget_detail_current: "Nu",
    widget_detail_actions: "Wat wil je doen?",
    widget_detail_no_actions: "Deze widget heeft geen directe acties — hij is puur informatief.",
    // App onboarding (PWA first launch)
    app_onboard_1_title: "Welkom bij Rostr",
    app_onboard_1_desc: "Slimme roosterplanning voor je hele team — plan, ruil en communiceer op één plek.",
    app_onboard_2_title: "Jouw team, één overzicht",
    app_onboard_2_desc: "Zie wie werkt, wie vrij is en wie er beschikbaar is. Nodig collega's uit met een simpele code.",
    app_onboard_3_title: "Nooit meer iets missen",
    app_onboard_3_desc: "Krijg meldingen over shifts, ruilverzoeken en verlofaanvragen. Blijf ingelogd — je hoeft je niet elke keer opnieuw aan te melden.",
    app_onboard_next: "Volgende",
    app_onboard_start: "Aan de slag",
    app_onboard_eyebrow: "Werkroosters, simpel",
    install_banner_title: "Installeer Rostr als app",
    install_banner_desc: "Sneller, met meldingen en altijd bereikbaar vanaf je startscherm.",
    install_banner_ios_pre: "Tik op",
    install_banner_ios_mid: "en kies",
    install_banner_ios_add: "Zet op beginscherm",
    pause_settings_desc: "Automatisch pauzeminuten toevoegen aan lange diensten op basis van de duur.",
    pause_desktop_only_hint: "Alleen instelbaar op de website.",
    auto_pause_enabled: "Auto-pauze inschakelen",
    auto_pause_enabled_hint: "Voeg automatisch pauze toe bij het aanmaken van een dienst.",
    pause_mode_flat: "Vaste regel",
    pause_mode_flat_hint: "Eén regel: vanaf X uur → altijd Y minuten pauze.",
    pause_mode_tiered: "Getrapte regels",
    pause_mode_tiered_hint: "Meerdere drempels, bv. 5u → 15m, 8u → 30m, 12u → 45m.",
    pause_threshold_hours: "Vanaf uren",
    pause_flat_minutes: "Pauzeduur (minuten)",
    pause_warning_ratio: "Waarschuwing bij pauze onder",
    pause_warning_ratio_hint: "% van de dienstduur — hierbij verschijnt een bevestigingspopup.",
    pause_tiers_desc: "Bepaal per drempel hoeveel pauze een dienst krijgt. Hoogste passende drempel wint.",
    pause_tier_from: "Vanaf",
    pause_tier_hours: "uur",
    pause_tier_minutes: "min",
    pause_tier_add: "Regel toevoegen",
    pause_tier_remove: "Verwijderen",
    pause_tiers_empty: "Nog geen regels ingesteld.",
    shift_max_length_error: "Een dienst mag maximaal 24 uur duren.",
    shift_moved: "Dienst verplaatst",
    drop_here: "Plaats hier",
    pause_warning_title: "Weet je het zeker?",
    pause_warning_body: "Deze dienst is {hours} uur maar heeft slechts {minutes} minuten pauze. Dat lijkt weinig.",
    pause_warning_confirm: "Ja, toch opslaan",
    pause_warning_cancel: "Terug",
    // v2 popup — Feb 2026 UX rework, clearer copy + visual current-vs-suggestion
    pause_warning_body_v2: "Deze dienst is {hours}u lang, maar er staat maar {minutes} min pauze in. Volgens je bedrijfsregel is dat aan de lage kant.",
    pause_warning_current_label: "Nu ingevuld",
    pause_warning_suggested_label: "Suggestie",
    pause_warning_cancel_v2: "Pauze aanpassen",
    pause_warning_confirm_v2: "Zo laten, opslaan",
    // Section 4 rework in PauseSettings — slider + concrete example
    pause_warning_title_v2: "Waarschuwing bij te weinig pauze",
    pause_warning_hint_v2: "Als iemand een pauze invoert die veel lager is dan je bedrijfsregel, laten we je een popup zien voordat je de dienst opslaat — zo voorkom je typefouten of overtredingen.",
    pause_warning_off_label: "Waarschuwing uit",
    pause_warning_on_label: "Waarschuwing aan",
    pause_warning_off_hint: "Je krijgt geen bevestigingspopup meer bij lage pauzes.",
    pause_warning_slider_label: "Waarschuw als pauze lager is dan",
    pause_warning_of_shift: "van de dienstduur",
    pause_warning_example_title: "Wat betekent dit concreet?",
    pause_warning_example_body: "Voorbeeld: bij een dienst van {ref}u zie je de popup zodra de pauze lager is dan {min} min.",
    // Hold-to-delete modal (Feb 2026) — stage 2 of the employee delete flow
    hold_delete_title: "Definitief verwijderen",
    hold_delete_emp_title: "Weet je het écht zeker?",
    hold_delete_emp_body: "Om te voorkomen dat je per ongeluk klikt: houd de rode knop 10 seconden vast. Laat je los, dan begint de teller opnieuw. Na 10 seconden is de medewerker weg — dit kan daarna niet meer ongedaan worden.",
    hold_delete_press: "Houd 10 seconden ingedrukt om te verwijderen",
    hold_delete_holding: "Vasthouden…",
    hold_delete_done: "Verwijderd",
    hold_delete_idle_hint: "Loslaten reset de teller. Klik 'Annuleren' om terug te gaan.",
    hold_delete_hold_hint: "Laat je los, dan begint de teller opnieuw.",
    hold_delete_done_hint: "Klaar — deze actie kan niet meer ongedaan worden gemaakt.",
    employee_deleted_final: "Medewerker definitief verwijderd",
    payroll_export_csv: "Exporteer CSV",
    payroll_export_success: "CSV-bestand gedownload",
    payroll_export_generated_at: "Gegenereerd op",
    payroll_export_details_header: "Detail per dienst",
    payroll_location_filter: "Filter op locatie",
    payroll_all_locations: "Alle locaties",
    pause_field_label: "Pauze (minuten)",
    pause_field_hint: "Laat leeg voor automatische berekening op basis van je bedrijfsinstellingen.",
    pause_auto_calculated: "Automatisch berekend uit je instellingen.",
    seat_modal_not_owner: "Alleen de eigenaar kan upgraden.",
    mw_title: "Welkom bij Rostr",
    mw_subtitle: "Nog één ding — hoe mogen je collega's je noemen? Deze naam verschijnt op je diensten en in de team-lijst.",
    mw_your_name: "Jouw weergavenaam",
    mw_placeholder: "bv. Jan de Vries",
    mw_editable_hint: "Je kunt dit altijd later aanpassen in je profiel.",
    mw_cta: "Doorgaan",
    mw_saving: "Bezig…",
    mw_success_title: "Alles staat klaar",
    mw_success_body: "Welkom, {name}. Veel plezier met Rostr!",
    handbook: "Handboek",
    handbook_eyebrow: "Rostr documentatie",
    handbook_title: "Handboek",
    handbook_role_owner: "Eigenaar",
    handbook_role_manager: "Manager",
    handbook_role_teamlead: "Teamleider",
    handbook_role_employee: "Medewerker",
    handbook_hero_title: "Alles wat je moet weten over jouw Rostr",
    handbook_hero_desc: "Deze gids is speciaal geschreven voor jouw rol. Zoek op trefwoord of blader door de secties hieronder — je vindt alle functies, hoe ze werken en wanneer je ze gebruikt.",
    handbook_search_placeholder: "Zoek in het handboek (bv. verlof, ruilen, meldingen)…",
    handbook_toc: "In dit handboek",
    handbook_empty_title: "Geen resultaten",
    handbook_empty_hint: "Probeer een ander trefwoord of wis de zoekopdracht.",
    handbook_footer_tip: "Nog vragen? Neem contact op met de eigenaar van je bedrijf, stuur een bericht via de nieuwsfeed of mail direct met ons supportteam:",
    login_extra_eyebrow: "Extra vragen",
    login_extra_title: "Nog vragen over Rostr?",
    login_extra_desc: "Kom je er niet uit, wil je een demo of heb je een idee om te delen? Mail ons — we helpen je persoonlijk en snel verder.",
    footer_support: "Support",
    leave_type: "Type verlof", vacation: "Vakantie", sick: "Ziek",
    personal: "Persoonlijk", unpaid: "Onbetaald", other: "Overig",
    availability_intro: "Geef aan welke tijden je beschikbaar bent per dag.",
    availability_saved: "Beschikbaarheid opgeslagen",
    monday: "Ma", tuesday: "Di", wednesday: "Wo", thursday: "Do",
    friday: "Vr", saturday: "Za", sunday: "Zo",
    week_of: "Week van", hours: "Uur",
    quick_actions: "Snelle acties", recent_activity: "Recente activiteit",
    broadcast: "Melding sturen", send: "Versturen", title: "Titel", body: "Bericht",
    all: "Iedereen", by_role: "Per rol", also_email: "Ook e-mailen",
    claim_shift: "Dienst claimen", yes: "Ja", no: "Nee",
    welcome_back: "Welkom terug", upcoming_shifts: "Aankomende diensten",
    request_status: "Status aanvragen", swap_shift: "Ruil deze dienst",
    unread: "ongelezen", empty_roster: "Geen diensten in deze week.",
    switch_role: "Rol", theme: "Thema", open_menu: "Menu", close: "Sluiten",
    company_side: "Beheer", employee_side: "Werknemer",

    // Dashboard
    greeting_night: "Goedenacht", greeting_morning: "Goedemorgen",
    greeting_afternoon: "Goedemiddag", greeting_evening: "Goedenavond",
    dashboard_subtitle: "Overzicht van je team: diensten, verlof, wissels en uren die op jouw goedkeuring wachten.",
    this_week: "Deze week", upcoming_shifts_hint: "Komende diensten",
    full_roster: "Volledig rooster", empty_upcoming_shifts: "Nog geen ingeplande diensten.",
    activity: "Activiteit", recent: "Recent", view_all: "Alle",
    empty_activity: "Nog stil hier.", shift_default: "Dienst",
    shifts_today: "Diensten vandaag", open_shifts_7d: "Open diensten (7 dg)",
    leave_waiting: "Verlof wacht", swaps_waiting: "Wissels wacht", hours_waiting: "Uren wacht",
    birthdays: "Verjaardagen", no_birthdays_week: "Niemand jarig in de komende 7 dagen.",
    upcoming_label: "Aankomende",
    birthdays_today_count: "vandaag", birthdays_upcoming_count: "deze week",

    // MyRoster
    my_roster_subtitle: "Je diensten, wissels en uren-registratie op één plek.",
    today_work_with: "Vandaag werk je met",
    colleague: "collega", colleagues: "collega's",
    empty_shifts_week_title: "Nog geen diensten in deze week",
    empty_shifts_week_hint: "Zodra je manager het rooster publiceert, verschijnen je diensten hier. Bekijk ook de open diensten hierboven om er zelf één te claimen.",

    // MyLeave
    leave_page_title: "Verlof",
    leave_page_subtitle: "Vraag verlof aan en volg de status van je aanvragen.",
    days_approved: "Dagen goedgekeurd", waiting_decision: "Wachtend op besluit",
    tab_all: "Alle", tab_pending: "Wachtend", tab_approved: "Goedgekeurd", tab_rejected: "Afgewezen",
    no_leave_requests: "Geen verlofaanvragen",
    no_leave_hint_all: "Klik op 'Verlof aanvragen' om je eerste aanvraag in te dienen.",
    no_leave_hint_cat: "Geen aanvragen in deze categorie.",
    choose_dates: "Kies een start- en einddatum",
    from_date: "Vanaf", until_date: "Tot",
    day_single: "dag", day_plural: "dagen", total_label: "totaal",
    reason_optional: "Reden (optioneel)",
    reason_placeholder: "Bijvoorbeeld: bruiloft, familiebezoek, verhuizing…",
    sick_admin_note_label: "Ziekmelding",
    sick_no_medical_help: "Rostr registreert alleen dát je je ziekmeldt en over welke periode. Vul hier geen diagnose, symptomen, oorzaak, behandeling of andere medische informatie in — dat verwerken we bewust niet.",
    sending: "Versturen…", send_request: "Aanvraag versturen",
    new_request: "Nieuwe aanvraag",
    requested_at: "Aangevraagd", decided_at: "Besluit",

    // MySwaps
    swap_page_title: "Ruilverzoeken",
    swap_page_subtitle: "Overzicht van je verstuurde en ontvangen dienstwissels.",
    tab_sent: "Verzonden", tab_received: "Ontvangen", tab_done: "Afgerond",
    no_swaps_title: "Nog geen ruilverzoeken in deze categorie",
    no_swaps_hint: "Vanuit 'Mijn rooster' kun je op een dienst klikken en om een ruil vragen.",
    in_progress_section: "In behandeling", active_count: "actief",
    history_section: "Geschiedenis", done_count: "afgerond",
    everyone_label: "Iedereen", you: "Jij",
    shift_label: "Dienst",
    waiting_manager: "Wacht op goedkeuring van je manager…",
    cancel_request: "Verzoek annuleren",
    created_at: "Aangemaakt",

    // News
    company_label: "Bedrijf",
    news_page_title: "Nieuws",
    news_page_subtitle: "Aankondigingen, verjaardagen en updates voor het hele team.",
    new_post: "Nieuw bericht",
    news_title_placeholder: "Titel — bv. 'Kerstborrel volgende week'",
    news_body_placeholder: "Wat wil je delen met je team?",
    pin_top: "Vastpinnen bovenaan",
    posting: "Plaatsen…", post: "Plaatsen",
    title_body_required: "Titel en bericht zijn vereist",
    post_published: "Bericht geplaatst",
    delete_post_confirm: "Bericht verwijderen?",
    deleted: "Verwijderd",
    birthday_today_title: "Vandaag jarig",
    congratulate: "Feliciteer je collega!",
    pinned_label: "Vastgepind",
    birthdays_month_title: "Jarig deze maand",
    birthdays_month_hint: "Aankomende verjaardagen bij het team",
    no_news_title: "Nog geen nieuws",
    no_news_hint_manager: "Plaats het eerste bericht om je team op de hoogte te houden.",
    no_news_hint_employee: "Zodra er iets nieuws is, verschijnt het hier.",
    news_empty_dismissed_title: "Inbox leeg",
    news_empty_dismissed_hint: "Je hebt alle berichten weggeswipet. Nieuwe berichten verschijnen hier zodra ze worden geplaatst.",
    news_restore_all: "Weggeswipete berichten herstellen",
    news_restore_hidden_prefix: "Toon",
    news_restore_hidden_one: "verborgen bericht weer",
    news_restore_hidden_many: "verborgen berichten weer",
    news_restored: "Berichten hersteld",
    news_swipe_hint: "Tip: swipe een bericht naar links om het voor jezelf te verbergen.",

    // Preferences
    back: "Terug",
    preferences_label: "Meldingen",
    preferences_subtitle: "Kies per soort update via welk kanaal je een melding wilt ontvangen.",
    how_notifs_work: "Zo werken meldingen",
    how_notifs_explain: "Kies per soort update via welk kanaal je een melding wilt ontvangen. Je kunt meerdere kanalen tegelijk aanzetten, of ze allemaal uitzetten als je een categorie liever niet wilt.",
    channel_app_hint: "verschijnt in het belletje-icoon rechtsboven wanneer je Rostr open hebt.",
    channel_email_hint: "naar het adres op je profiel. Handig als je Rostr niet vaak open hebt.",
    channel_push_hint: "pop-up op je telefoon of laptop, óók als Rostr niet actief is. Zet hem hieronder aan.",
    push_on_device: "Push aan op dit apparaat",
    push_active: "Actief. Test met de knop hieronder.",
    active: "Actief",
    inactive: "Inactief",
    pause_disabled_note: "Diensten krijgen geen automatische pauze",
    pause_save_hint: "Wijzigingen worden pas actief na Opslaan.",
    pause_tiers_count: "regels",
    pause_preview_title_v2: "Zo werkt jouw pauze-regel",
    pause_preview_subtitle: "Live voorbeeld — updatet terwijl je wijzigt",
    pause_try_it: "Probeer het uit",
    pause_try_hint: "Sleep de duur ↓",
    pause_hours_worked: "uur ingepland",
    pause_label: "Pauze",
    pause_explain_title: "Hoe werkt het?",
    pause_explain_body: "Rostr trekt de pauze automatisch van de dienst af zodra iemand langer dan de drempel werkt. De medewerker ziet netto-uren; jij ziet het bruto rooster.",
    pause_reference_examples: "Voorbeelden",
    dashboard_row_kpis: "Kerncijfers",
    dashboard_row_details: "Details & inzichten",
    quick_add_desc: "Snel toevoegen zonder de pagina te verlaten",
    qa_desc_employee: "Verstuur een uitnodiging naar een nieuwe medewerker",
    qa_desc_location: "Voeg een nieuwe locatie toe aan je organisatie",
    qa_desc_team: "Maak een nieuw team aan om medewerkers te groeperen",
    qa_desc_broadcast: "Stuur iedereen in de organisatie een bericht",
    location_created: "Locatie toegevoegd",
    team_created: "Team toegevoegd",
    broadcast_sent: "Bericht verstuurd",
    broadcast_title_ph: "Onderwerp",
    broadcast_body_ph: "Wat wil je iedereen laten weten?",
    field_required: "Vul alle velden in",
    swap_subtitle: "Beoordeel dienstwissels van je team op één plek",
    swap_filter_actionable: "Actiegericht",
    swap_filter_all: "Alle",
    swap_filter_pending: "Wachtend",
    swap_filter_accepted: "Klaar voor akkoord",
    swap_filter_approved: "Goedgekeurd",
    swap_filter_rejected: "Afgewezen",
    swap_empty_title: "Geen ruilverzoeken",
    swap_empty_actionable: "Er is niks dat op jouw goedkeuring wacht.",
    swap_empty_hint: "Zodra je team diensten wil ruilen, verschijnen ze hier.",
    swap_awaiting_target: "Wacht op reactie van collega",
    swap_ready_for_approval: "Beide werknemers akkoord — jouw goedkeuring nodig",
    push_allow: "Sta pop-ups toe zodat push werkt.",
    on: "Aan", off: "Uit",
    test_notification: "Test-melding",
    notification_types: "Soorten meldingen",
    pref_categories: "categorieën aan",
    phone_on: "Telefoon aan", phone_off: "Telefoon uit",
    notifs_off_toast: "Meldingen uitgezet", notifs_on_toast: "Meldingen aan",
    action_failed: "Actie mislukt",
    test_sent: "Test-melding verzonden", test_failed: "Test mislukt",
    couldnt_save: "Kon niet opslaan",
    cat_leave_desc: "Wanneer je manager je aanvraag goedkeurt of afwijst",
    cat_swap_desc: "Als een collega jou vraagt om een dienst te ruilen — of jouw voorstel wordt beantwoord",
    cat_news_desc: "Aankondigingen van je manager of HR in de nieuws-feed",
    cat_birthday_desc: "Wanneer een collega jarig is, zodat je hem of haar kunt feliciteren",
    cat_roster_desc: "Als je manager een nieuwe week publiceert of jouw dienst wijzigt",
    cat_leave: "Verlof", cat_swap: "Ruilverzoeken", cat_news: "Nieuws",
    cat_birthday: "Verjaardagen", cat_roster: "Rooster",
    appearance: "Weergave", light: "Licht", dark: "Donker",
    light_desc: "Klassiek en helder", dark_desc: "Rustig voor je ogen",
    language_label: "Taal",
    lang_set: "Taal",
    channel_app: "App", channel_email: "E-mail", channel_push: "Push",
    notifications_page_title: "Meldingen",
    notifications_page_subtitle: "Bepaal per soort update via welk kanaal je bericht krijgt.",
    pref_all_off: "Alles staat uit — je krijgt geen meldingen.",
    pref_all_on: "Je krijgt meldingen voor alle categorieën.",
    pref_some_on: "Sommige categorieën staan aan, andere uit.",
    pref_footer_hint: "Push werkt óók als de app dicht is — voeg Rostr eerst toe aan je startscherm (PWA). Thema en taal wijzig je in je Profiel.",

    // Team Today (mobile manager view)
    team_today_nav: "Vandaag",
    team_today_title: "Team vandaag",
    team_today_subtitle: "Wie is er nu, wie komt straks en wie is klaar.",
    team_today_working_one: "collega momenteel aan het werk",
    team_today_working_many: "{n} collega's momenteel aan het werk",
    team_now_working: "Nu aan het werk",
    team_later_today: "Later vandaag",
    team_done_today: "Al klaar vandaag",
    team_no_one_working: "Er staat nu niemand ingepland.",
    team_no_upcoming_today: "Geen diensten meer vandaag.",
    team_no_done_yet: "Nog niemand klaar.",

    // Quick Assign (mobile manager view)
    quick_assign_nav: "Toewijzen",
    quick_assign_eyebrow: "Open diensten",
    quick_assign_title: "Snel toewijzen",
    quick_assign_subtitle: "Tik op een open dienst en kies direct wie hem overneemt.",
    quick_open_one: "open dienst wacht op een medewerker",
    quick_open_many: "{n} open diensten wachten op een medewerker",
    quick_all_covered: "Alles bedekt",
    quick_all_covered_hint: "Er staan geen open diensten in de komende 7 dagen.",
    quick_today: "Vandaag",
    quick_tap_assign: "Toewijzen",
    quick_pick_employee: "Kies een medewerker",
    quick_search_placeholder: "Zoek op naam of functie…",
    quick_available: "Vrij",
    quick_conflict_short: "Overlap",
    quick_role_mismatch: "Andere functie dan de dienst",
    quick_role_mismatch_short: "Rol",
    quick_no_match: "Geen medewerkers gevonden.",
    quick_assigned: "Dienst toegewezen",
    quick_conflict: "Overlap met bestaande dienst",

    // Manager Requests (mobile: leave + swaps + time approvals in one place)
    requests_nav: "Aanvragen",
    requests_eyebrow: "Vandaag beslissen",
    requests_title: "Aanvragen",
    requests_subtitle: "Verlof, ruilverzoeken en uren die op jouw akkoord wachten.",
    requests_one_pending: "aanvraag wacht op je akkoord",
    requests_many_pending: "{n} aanvragen wachten op je akkoord",
    requests_tab_leave: "Verlof",
    requests_tab_swap: "Ruilen",
    requests_tab_time: "Uren",
    requests_no_leave: "Geen verlofaanvragen open.",
    requests_no_swap: "Geen ruilverzoeken om goed te keuren.",
    requests_no_time: "Geen uren om goed te keuren.",
    leave_approved: "Verlof goedgekeurd",
    leave_rejected: "Verlof afgewezen",
    hours_approved: "Uren goedgekeurd",
    hours_rejected: "Uren afgewezen",

    // Billing
    billing_label: "Abonnement",
    billing_page_title: "Abonnement & facturatie",
    billing_page_subtitle_owner: "Beheer je Rostr-abonnement en factuurgegevens. Alleen jij als eigenaar hebt hier toegang.",
    billing_page_subtitle_view: "Bekijk je abonnementsstatus. Alleen de eigenaar kan aanpassingen doen.",
    billing_status_trial: "Proefperiode",
    billing_status_active: "Actief",
    billing_status_past_due: "Betaling openstaand",
    billing_status_cancelled: "Opgezegd",
    billing_status_expired: "Verlopen",
    billing_status_unpaid: "Nog geen abonnement",
    // Paywall (Dashboard banner for owner) + Welcome onboarding page
    paywall_banner_title: "Je mag rondkijken — maar zonder abonnement werkt niets",
    paywall_banner_body: "Je kunt de app verkennen, maar niks aanmaken of aanpassen. Medewerkers toevoegen, roosters maken, verlof indienen, uitnodigingen versturen — alles is uitgeschakeld tot je een abonnement kiest. Alleen jij als Eigenaar kunt dit oplossen.",
    paywall_choose_plan: "Kies nu een abonnement",
    welcome_eyebrow: "Je bedrijf is aangemaakt",
    welcome_title_named: "Welkom bij Rostr, {name}.",
    welcome_title_plain: "Welkom bij Rostr.",
    welcome_intro_p1: "Rostr regelt je hele werkplanning: van rooster maken en verlof goedkeuren tot uren registreren en salaris klaarzetten — voor teams van 2 tot 500 medewerkers.",
    welcome_intro_p2: "Je bedrijf staat klaar en is compleet leeg — geen medewerkers, geen locaties, geen diensten. Zodra je een abonnement kiest kun je alles zelf inrichten en direct beginnen.",
    welcome_f1_title: "Slim rooster",
    welcome_f1_desc: "Sleep diensten, kopieer weken, publiceer in één klik — met sjablonen en terugkerende diensten.",
    welcome_f2_title: "Verlofaanvragen",
    welcome_f2_desc: "Werknemers vragen aan, jij keurt goed. Notificaties per e-mail en in-app, geen losse chats meer.",
    welcome_f3_title: "Diensten ruilen",
    welcome_f3_desc: "Collega's ruilen onderling — met of zonder manager-goedkeuring, jij bepaalt de regels.",
    welcome_f4_title: "Medewerkers & locaties",
    welcome_f4_desc: "Onbeperkt medewerkers, teams en locaties. Rollen: Eigenaar, Manager, Teamleider en Medewerker.",
    welcome_f5_title: "Rapporten & payroll",
    welcome_f5_desc: "Uren per week, contracturen versus gepland, CSV-exports en payroll-overzicht voor je boekhouder.",
    welcome_f6_title: "Fijnmazige rechten",
    welcome_f6_desc: "Geef teamleiders precies de rechten die ze nodig hebben — per locatie of per taak.",
    welcome_f7_title: "Notificaties",
    welcome_f7_desc: "Rooster gepubliceerd, verlof beslist, dienst geruild — iedereen weet het meteen.",
    welcome_f8_title: "Documenten",
    welcome_f8_desc: "Contracten, protocollen en veiligheidsdocumenten centraal — met wie je wilt delen.",
    welcome_f9_title: "Handbook & support",
    welcome_f9_desc: "Rolspecifiek handboek in de app én persoonlijke support via rosterhelp@gmail.com.",
    welcome_decide_eyebrow: "Nog één stap",
    welcome_decide_title: "Klaar om Rostr voor je team in gebruik te nemen?",
    welcome_decide_body: "Kies een abonnement en start met inrichten. Vanaf € 12,99 per maand voor het hele bedrijf — alleen de eigenaar betaalt.",
    welcome_cta_yes: "Ja, kies een abonnement",
    welcome_cta_later: "Niet nu — ik kijk eerst rond",
    welcome_pick_now: "Kies dit plan",
    welcome_later_hint: "Je mag gerust rondkijken, maar zonder actief abonnement kun je niks aanmaken of aanpassen. De app werkt pas volledig zodra je een plan hebt gekozen.",
    // Info banner shown to Manager/Teamlead when tenant is locked
    waiting_banner_body: "Je bedrijf wacht op een actief abonnement. Zodra de eigenaar een plan kiest, kun je weer diensten en verlof aanpassen.",
    // "Best for" comparison labels on Billing plan cards
    plan_best_for_starter_monthly: "Beste voor: klein team, 1 locatie",
    plan_best_for_team_monthly: "Beste voor: horeca & retail met 1-2 locaties",
    plan_best_for_business_monthly: "Beste voor: meerdere locaties of een keten",
    plan_best_for_scale_monthly: "Beste voor: grote organisatie of scale-up",
    // Feature-list per plan (Billing.jsx & Welcome.jsx). Kept short so cards
    // stay balanced in the 4-col grid.
    plan_feat_starter_monthly_1: "Tot 15 medewerkers",
    plan_feat_starter_monthly_2: "1 locatie, onbeperkt teams",
    plan_feat_starter_monthly_3: "Rooster, verlof en ruilverzoeken",
    plan_feat_starter_monthly_4: "E-mail support",
    plan_feat_team_monthly_1: "Tot 40 medewerkers",
    plan_feat_team_monthly_2: "1-2 locaties met scoping",
    plan_feat_team_monthly_3: "Sjablonen + terugkerende diensten",
    plan_feat_team_monthly_4: "Payroll-overzicht & CSV-export",
    plan_feat_business_monthly_1: "Tot 100 medewerkers",
    plan_feat_business_monthly_2: "Onbeperkt locaties + granulaire rechten",
    plan_feat_business_monthly_3: "Documenten & rapporten",
    plan_feat_business_monthly_4: "Prioritaire e-mail support",
    plan_feat_scale_monthly_1: "Tot 500 medewerkers",
    plan_feat_scale_monthly_2: "Multi-locatie & keten-tooling",
    plan_feat_scale_monthly_3: "SSO klaar (Google & Microsoft)",
    plan_feat_scale_monthly_4: "Onboarding-call + SLA",
    billing_trial_title: "Gratis proefperiode",
    billing_current_title: "Huidig abonnement",
    billing_trial_days_left: "Nog {n} dagen in je proefperiode.",
    billing_trial_expired_hint: "Je proefperiode is voorbij — kies een abonnement om verder te gaan.",
    billing_plan: "Plan",
    billing_renews_on: "verlengt op",
    billing_manage: "Beheren",
    billing_manage_title: "Abonnement beheren",
    billing_manage_desc: "Bekijk je facturen, wijzig je betaalmethode, of pauzeer/annuleer je abonnement via het beveiligde Stripe-portaal.",
    billing_open_portal: "Open Stripe-portaal",
    billing_cancel_subscription: "Abonnement annuleren",
    billing_cancel_confirm_title: "Weet je zeker dat je wilt annuleren?",
    billing_cancel_confirm_body: "Je wordt doorgestuurd naar Stripe om je abonnement definitief te annuleren. Je team blijft toegang houden tot het einde van de huidige facturatieperiode.",
    billing_cancel_confirm_cta: "Ja, doorgaan",
    billing_locked_title: "App vergrendeld",
    billing_locked_body: "Je proefperiode is voorbij. Kies een abonnement om Rostr weer voor je hele team beschikbaar te maken.",
    profile_section_data: "Gegevens",
    profile_section_prefs: "Voorkeuren",
    billing_choose_plan: "Kies een plan",
    billing_recommended: "Aanbevolen",
    billing_per_month: "maand",
    billing_up_to_x_employees: "Tot {n} werknemers",
    billing_range_employees: "{min}–{max} werknemers",
    billing_unlimited_employees: "Onbeperkt werknemers",
    billing_all_features: "Alle functies",
    billing_email_support: "E-mail support",
    billing_start_plan: "Start abonnement",
    billing_custom_eyebrow: "Meer dan 500 medewerkers?",
    billing_custom_title: "Custom plan op maat",
    billing_custom_desc: "Heb je meer dan 500 medewerkers of extra rollen, integraties of SLA nodig? Stuur ons een e-mail — we maken een plan op maat voor je organisatie.",
    billing_custom_cta: "Vraag custom plan aan",
    billing_all_plans: "Alle abonnementen",
    billing_current_plan: "Huidig",
    billing_switch_to_plan: "Wissel naar dit plan",
    billing_not_owner_hint: "Alleen de eigenaar van je bedrijf kan het abonnement beheren. Neem contact op met de eigenaar voor vragen over facturatie.",
    billing_confirming: "Betaling bevestigen…",
    billing_confirming_hint: "Even geduld — Stripe rondt de betaling af.",
    billing_paid_title: "Betaling geslaagd",
    billing_paid_body: "Bedankt! Je abonnement is actief. Je team kan meteen weer aan de slag.",
    billing_confirm_failed: "Kon betaling niet bevestigen",
    billing_back: "Terug naar Abonnement",
    billing_cancel_title: "Betaling geannuleerd",
    billing_cancel_body: "Geen probleem — je bent teruggekeerd zonder iets te betalen. Je kunt op elk moment een abonnement starten.",

    // Login page
    new_badge: "Nieuw · werkplanning",
    hero_line1: "Personeelsplanning",
    hero_line2: "zonder gedoe.",
    hero_desc: "Plan diensten, beheer verlof en houd uren en teams overzichtelijk op één plek.",
    create_company_cta: "Bedrijf aanmaken",
    have_invite_cta: "Ik heb een uitnodigingscode",
    trust_30_days: "Rustig proberen",
    trust_invites: "Uitnodigingscodes",
    trust_langs: "2 talen",
    trust_mobile: "Mobiel-vriendelijk",
    of_with_email: "of met e-mail",
    all_in_one: "Alles-in-één",
    from_roster_to_pay: "Van roosterchaos naar rust.",
    everything_you_need: "Alles wat je nodig hebt om je team te plannen — en niets meer.",
    hl_smart_roster: "Slim rooster",
    hl_smart_roster_desc: "Sleep diensten, plan per week of dag, en publiceer in één klik naar je team.",
    hl_leave: "Verlof zonder papierwerk",
    hl_leave_desc: "Werknemers vragen aan, jij keurt goed. Notificaties per e-mail en in-app.",
    hl_swaps: "Dienstwissels",
    hl_swaps_desc: "Collega's ruilen onderling — met of zonder manager-goedkeuring.",
    hl_hours: "Uren-registratie",
    hl_hours_desc: "Werkelijke start- en eindtijden vastleggen en goedkeuren.",
    hl_roles: "3 rollen, één werkplek",
    hl_roles_desc: "Manager, Teamleider en Medewerker — met exact de juiste rechten.",
    landing_stat_roles: "Rollen",
    landing_stat_trial: "Gratis proberen",
    landing_stat_langs: "Talen",
    google_login: "Inloggen met Google",
    google_create_company: "Bedrijf aanmaken met Google",
    google_continue: "Doorgaan met Google",
    hl_notifs: "Directe meldingen",
    hl_notifs_desc: "Rooster gepubliceerd, verlof beslist of wissel voorgesteld — iedereen weet het meteen.",
    pricing: "Prijs",
    try_30_days: "Rustig proberen.",
    pricing_desc: "Geen creditcard vereist. Rustig testen met je hele team. Daarna een simpel abonnement per bedrijf — alleen de Eigenaar betaalt.",
    start_now: "Nu starten", more_questions: "Meer vragen?",
    faq: "FAQ", faq_title: "Kort en goed.",
    faq_q1: "Wie kan een bedrijf aanmaken?",
    faq_a1: "Iedereen. Wie het bedrijf aanmaakt wordt automatisch Eigenaar en beheert medewerkers en instellingen.",
    faq_q2: "Hoe komen werknemers erbij?",
    faq_a2: "Je genereert een unieke uitnodigingscode per rol. Werknemers vullen die in bij 'Ik heb een uitnodigingscode' of gebruiken de link uit hun mail.",
    faq_q3: "Werkt Google-inloggen?",
    faq_a3: "Ja. Op de login-, aanmeld- en aansluiten-pagina staat 'Inloggen met Google'. Geen wachtwoord nodig.",
    faq_q4: "Kan ik meerdere locaties beheren?",
    faq_a4: "Ja. Locaties, teams en rollen zijn onbeperkt binnen je bedrijf.",
    faq_q5: "Werkt het op mobiel?",
    faq_a5: "Ja. De app is fully responsive met een aparte bottom-navigatie voor werknemers op hun telefoon.",
    nav_features: "Functies", nav_pricing: "Prijzen", nav_faq: "FAQ",
    footer_privacy: "Privacy", footer_terms: "Voorwaarden", footer_support: "Support",
    footer_tagline: "werkplanning",
    // Fase 6.2 — Productwaarde-sectie op publieke landing
    landing_product_eyebrow: "Wat je met Rostr doet",
    landing_product_title: "Alles voor je personeelsplanning op één plek.",
    landing_product_desc: "Zes duidelijke bouwblokken — géén hijgerige marketing, gewoon de functionaliteit die er is.",
    pv_roster_title: "Rooster",
    pv_roster_desc: "Diensten plannen per week of dag, per locatie of team, en publiceren wanneer je klaar bent.",
    pv_leave_title: "Verlof",
    pv_leave_desc: "Aanvragen, goedkeuren of afwijzen — met inzicht in wie wanneer weg is.",
    pv_hours_title: "Uren",
    pv_hours_desc: "Werkelijke start- en eindtijden vastleggen, controleren en goedkeuren.",
    pv_employees_title: "Medewerkers",
    pv_employees_desc: "Team, contract, contactgegevens en rechten centraal beheerd per medewerker.",
    pv_reports_title: "Rapportages",
    pv_reports_desc: "Live overzichten en CSV-exports voor rooster, verlof en uren.",
    pv_locations_title: "Meerdere locaties",
    pv_locations_desc: "Vestigingen, teams en rollen apart houden — zonder in aparte omgevingen te werken.",

    // CreateCompany
    step_of: "Stap {n} van 2",
    tell_company: "Vertel ons over je bedrijf",
    your_account: "Nu jouw account",
    company_data_help: "Deze gegevens zetten we in je bedrijfsinstellingen. Je kunt ze later aanpassen.",
    owner_note: "Je wordt de Eigenaar van dit bedrijf — je beheert medewerkers en instellingen.",
    company_name: "Bedrijfsnaam",
    industry: "Branche", size: "Grootte", country: "Land",
    size_employees: "medewerkers",
    first_name: "Voornaam", last_name: "Achternaam",
    fastest_option: "Snelste optie — geen wachtwoord nodig",
    or_email_password: "of met e-mail + wachtwoord",
    email_addr: "E-mailadres",
    min_6_chars: "Min. 6 tekens",
    working: "Bezig...",
    create_company: "Bedrijf aanmaken",
    already_account: "Al een account? Log in",
    no_credit_card: "Geen creditcard vereist",
    welcome_company: "Welkom bij Rostr",

    // JoinCompany
    join_company_title: "Aansluiten bij een bedrijf",
    fill_invite: "Vul je uitnodigingscode in",
    create_account: "Maak je account",
    invitation_code: "Uitnodigingscode",
    invalid_code: "Ongeldige code",
    checking: "Controleren...",
    verify_code: "Verifieer code",
    invited_by: "uitgenodigd door",
    birthday_field: "Geboortedatum",
    joining: "Aansluiten",
    welcome_team: "Welkom bij het team",

    // Employees
    search_placeholder: "Zoeken...",
    invite_code_btn: "Uitnodigingscode",
    job_function: "Functie", department_col: "Afdeling", birthday_col: "Verjaardag",
    job_placeholder: "bv. Barista, Verpleegkundige",
    dept_placeholder: "bv. Sales, Keuken, IT",
    code_copied: "Code {code} gekopieerd (rol: {role})",
    code_error: "Kon geen code aanmaken",
    close_label: "Sluiten",

    // Notifications
    no_notifs_title: "Nog geen meldingen",
    no_notifs_hint: "Je krijgt hier meldingen over nieuwe diensten, verlof-beslissingen en ruilverzoeken.",
    target: "Doelgroep",

    // Profile
    profile_subtitle: "Beheer je gegevens en voorkeuren.",
    my_overview_section: "Mijn overzicht",
    my_overview_nav: "Mijn overzicht",
    my_overview_eyebrow: "Mijn overzicht",
    my_overview_title: "Mijn overzicht",
    my_overview_subtitle: "Je verlof, je verwachte uitbetaling en jarige collega's — allemaal op één plek.",
    view_day: "Dag",
    view_week: "Week",
    approved: "Goedgekeurd",
    remaining: "Rest",
    year: "Jaar",
    days: "dagen",
    day_free: "Geen dienst — vrije dag",
    day_free_past: "Vrije dag",
    my_details: "Gegevens",
    birthday_privacy_hint: "Je collega's zien de dag/maand, het jaartal blijft privé.",
    session: "Sessie",
    logout_device: "Log uit op dit apparaat.",
    preferences_desc: "Push, e-mail en in-app meldingen per soort update.",

    // Roster
    roster_subtitle: "Plan diensten in, wijs medewerkers toe en publiceer per week.",
    all_locations: "Alle locaties", filter: "Filter",
    empty_roster_hint: "Klik op '+' in een dag of gebruik 'Dienst toevoegen' om je eerste dienst in te plannen.",
    edit_shift: "Dienst bewerken",
    shift_role_placeholder: "Kok, bediening, ondersteuning...",
    copy_prev_week: "Kopieer vorige week",
    copy_prev_week_hint: "Dupliceer alle diensten van vorige week naar deze week (concept)",
    copied_shifts: "diensten gekopieerd",
    total_hours: "Totaal uren",
    hours_per_employee: "Uren per medewerker",
    planned: "gepland",
    copy_menu: "Kopieer",
    copy_to_next_week: "Kopieer naar volgende week",
    copy_to_next_week_hint: "Dupliceer deze week naar volgende week als concept",
    copy_pick_days: "Kies dagen…",
    copy_pick_days_hint: "Kopieer 1 of meer dagen naar zelfgekozen doeldagen",
    copy_days_title: "Kopieer dagen",
    copy_days_h: "Kies bron- en doeldagen",
    copy_days_hint: "Selecteer welke dagen deze week je wilt kopiëren en waar naartoe. Alle diensten van geselecteerde brondagen worden als concept aangemaakt op elke doeldag.",
    copy_step_source: "Welke dagen kopiëren?",
    copy_step_target: "Naar welke dagen?",
    copy_pick_both: "Kies zowel bron- als doeldagen",
    copy_keep_employee: "Behoud toegewezen medewerkers",
    copy_keep_employee_hint: "Uit = doeldagen worden onbezet",
    copy_now: "Kopieer nu",
    copying: "Kopiëren…",
    shifts_will_be_created: "diensten worden aangemaakt",
    shifts_short: "d.",
    no_shifts_yet: "Nog geen diensten voor deze dag",
    shift_singular: "dienst",
    shifts: "diensten",
    shifts_selected: "diensten",
    select_week: "Hele week",
    duplicate_shift: "Dupliceer +1 dag",
    duplicate_shift_hint: "Maak een kopie op de volgende dag",
    shift_duplicated: "Dienst gedupliceerd naar morgen",
    view_by_day: "Per dag",
    view_by_employee: "Per medewerker",
    // Mobile roster (Manager / Teamleider)
    mroster_selected_day: "Geselecteerde dag",
    mroster_tab_shifts: "Diensten",
    mroster_tab_team: "Team",
    mroster_off_today: "Geen dienst vandaag",
    mroster_unassigned_single: "1 dienst is nog niet toegewezen aan een medewerker",
    mroster_unassigned_multi: "{n} diensten zijn nog niet toegewezen",
    mroster_team_summary: "{working} van {total} medewerkers werken vandaag",
    mroster_empty_hint: "Tik op de + knop om een dienst voor deze dag toe te voegen.",
    no_employees_yet: "Nog geen medewerkers",
    // Shift overlap
    shift_overlap_title: "Dienst overlapt met bestaande dienst",
    shift_overlap_desc: "Deze medewerker heeft al een dienst in dit tijdvenster op deze dag. Kies een ander tijdstip of pas de bestaande dienst aan.",
    existing_shift: "Bestaande dienst",
    conflict_understood: "Begrepen",
    copy_partial_title: "Enkele diensten zijn overgeslagen",
    copy_partial_desc: "De volgende diensten conflicteerden met bestaande diensten en zijn overgeslagen:",
    copy_partial_created: "gekopieerd",
    copy_partial_skipped: "overgeslagen door overlap",
    contact_info: "Contactgegevens",
    no_upcoming_shifts: "Geen aankomende diensten",
    no_upcoming_shifts_hint: "Deze medewerker heeft geen ingeplande diensten in de komende 60 dagen.",
    emp_tab_overview: "Overzicht",
    emp_tab_leave: "Verlof",
    emp_tab_swap: "Ruilen",
    emp_no_leave_title: "Geen verlofaanvragen",
    emp_no_leave_hint: "Deze medewerker heeft nog geen verlof aangevraagd.",
    emp_no_swap_title: "Geen ruilverzoeken",
    emp_no_swap_hint: "Deze medewerker heeft nog geen dienstwissels.",
    emp_swap_from: "Aanvrager",
    emp_swap_to: "Ontvanger",

    // Welcome intro
    welcome_hello: "Hallo",
    welcome_there: "daar",
    welcome_tagline: "Rooster · team · rust",
    welcome_intro_desc: "Fijn dat je er weer bent. Even een kort overzicht van wat er op je wacht.",
    welcome_summary_eyebrow: "Wat wacht er op je",
    welcome_summary_title: "Klaar om te beginnen?",
    welcome_summary_empty: "Alles is up-to-date",
    welcome_summary_empty_desc: "Niets urgents op dit moment. Fijne werkdag!",
    welcome_next: "Volgende",
    welcome_start: "Naar dashboard",
    welcome_skip: "Overslaan",
    welcome_unread_notifications: "{n} ongelezen meldingen",
    welcome_pending_leave: "{n} verlofaanvragen te beoordelen",
    welcome_pending_swaps: "{n} ruilverzoeken te beoordelen",
    welcome_pending_time: "{n} uren goed te keuren",
    welcome_open_shifts: "{n} openstaande diensten",
    welcome_shifts_this_week: "{n} diensten deze week",
    welcome_my_shifts_today: "{n} diensten vandaag",
    welcome_my_shifts_week: "{n} diensten deze week",
    welcome_pending_own_leave: "{n} verlofaanvragen wachtend",
    welcome_claimable_shifts: "{n} open diensten om te claimen",

    // Customizable dashboard widgets
    customize_dashboard: "Aanpassen",
    widget_picker_title: "Kies je widgets",
    widget_picker_subtitle: "Zet aan wat je wilt zien op je dashboard. Max 20.",
    widget_reset: "Standaard herstellen",
    dashboard_empty_title: "Kies je eerste widgets",
    dashboard_empty_desc: "Personaliseer je dashboard met de informatie die jij belangrijk vindt.",
    widget_cat_stats: "Kerncijfers",
    widget_cat_personal: "Mijn werk",
    widget_cat_team: "Team",
    widget_cat_planning: "Planning",
    widget_cat_requests: "Aanvragen",
    widget_cat_updates: "Updates",
    widget_cat_actions: "Snelle acties",
    // Widget titles + descriptions
    w_stat_employees: "Medewerkers",
    w_stat_employees_desc: "Totaal aantal medewerkers in je bedrijf.",
    w_stat_shifts_week: "Diensten deze week",
    w_stat_shifts_week_desc: "Alle geplande diensten voor de aankomende 7 dagen.",
    w_stat_open_shifts: "Openstaande diensten",
    w_stat_open_shifts_desc: "Diensten zonder toegewezen medewerker.",
    w_stat_pending_leave: "Verlof wachtend",
    w_stat_pending_leave_desc: "Verlofaanvragen die op je goedkeuring wachten.",
    w_stat_pending_swaps: "Wissels wachtend",
    w_stat_pending_swaps_desc: "Dienstwissels die op beslissing wachten.",
    w_stat_pending_time: "Uren wachtend",
    w_stat_pending_time_desc: "Timesheets die op goedkeuring wachten.",
    w_stat_locations: "Locaties",
    w_stat_locations_desc: "Aantal locaties/vestigingen.",
    w_stat_teams: "Teams",
    w_stat_teams_desc: "Aantal teams binnen je bedrijf.",
    w_stat_total_hours: "Totaal uren week",
    w_stat_total_hours_desc: "Alle geplande uren voor deze week.",
    w_my_shifts: "Mijn diensten",
    w_my_shifts_desc: "Jouw eigen aankomende diensten.",
    w_team_today: "Team vandaag",
    w_team_today_desc: "Wie werkt er vandaag en op welke tijden.",
    w_recent_activity: "Recente activiteit",
    w_recent_activity_desc: "Laatste meldingen en updates.",
    w_recent_news: "Recent nieuws",
    w_recent_news_desc: "Laatste berichten van je team.",
    w_upcoming_birthdays: "Verjaardagen",
    w_upcoming_birthdays_desc: "Wie is er jarig deze week.",
    w_pending_leave_list: "Verlofaanvragen",
    w_pending_leave_list_desc: "Overzicht van openstaande verlofaanvragen.",
    w_open_shifts_list: "Open diensten",
    w_open_shifts_list_desc: "Onbezette diensten in de komende week.",
    w_top_hours: "Top uren per medewerker",
    w_top_hours_desc: "Wie werkt het meeste deze week.",
    w_quick_actions: "Snelle acties",
    w_quick_actions_desc: "Snel een dienst, medewerker of locatie toevoegen.",
    w_week_calendar: "Weekkalender",
    w_week_calendar_desc: "Mini-kalender met alle diensten van deze week.",
    w_hours_bar: "Uren per dag",
    w_hours_bar_desc: "Bar chart van geplande uren per weekdag.",
    // Manager-specifieke widgets
    w_urgent_open: "Onbezet-alarm",
    w_urgent_open_desc: "Open diensten in de komende 48 uur — rood wanneer <24u.",
    w_publish_status: "Publish-status",
    w_publish_status_desc: "Percentage gepubliceerde diensten per dag deze week.",
    w_roster_horizon: "Rooster-horizon",
    w_roster_horizon_desc: "Hoeveel dagen vooruit staat het rooster.",
    w_leave_taken_ytd: "Verlof genomen dit jaar",
    w_leave_taken_ytd_desc: "Top 5 medewerkers met meest verlof dit jaar.",
    w_broadcast_composer: "Meldingsbericht sturen",
    w_broadcast_composer_desc: "Direct een bericht naar iedereen of per rol vanuit dashboard.",
    days_short: "d",
    field_locked_badge: "Vergrendeld",
    field_locked_hint: "Alleen je manager of teamleider kan dit aanpassen. Vraag hen om je gegevens bij te werken.",

    // Manager online hint
    manager_online_hint_title: "Meer functies staan online",
    manager_online_hint_body: "Rooster maken, verlof goedkeuren, medewerkers beheren en rapportages downloaden doe je op je account op de website.",
    // Birthday celebrate reaction
    celebrate: "Feest mee",
    celebrated: "Je viert mee",
    celebrated_hint: "Bericht verstuurd naar de jarige",
    // Shift notes
    shift_notes: "Opmerkingen",
    shift_notes_placeholder: "bv. Koeling ook graag organiseren, take-away pieken tussen 12–14u...",
    shift_notes_hint: "Zichtbaar voor de medewerker bij zijn dienst.",
    // Claim warning
    warning: "Let op",
    claim_warning_title: "Weet je zeker dat je deze dienst wil overnemen?",
    claim_warning_reason: "Deze dienst is voor een andere functie dan die van jou. Overnemen kan betekenen dat je taken doet buiten je normale rol.",
    claim_warning_hint: "Twijfel je? Overleg eerst met je manager of teamleider voordat je bevestigt.",
    claim_warning_confirm: "Ja, ik neem hem over",
    shift_role: "Dienst-functie",
    your_role: "Jouw functie",
    reason: "Reden",
    // Sidebar sections
    navsec_planning: "Plannen",
    navsec_team: "Team",
    navsec_requests: "Aanvragen",
    navsec_insights: "Inzicht & updates",
    navsec_system: "Systeem",
    navsec_my_work: "Mijn werk",
    navsec_updates: "Updates & account",
    // Phase 9B.2 — role-specific navigation
    navsec_time_absence: "Tijd & afwezigheid",
    navsec_insights_v2: "Inzicht",
    navsec_communication: "Communicatie",
    navsec_admin: "Beheer",
    navsec_day_ops: "Dagoperatie",
    navsec_account: "Account",
    more_nav: "Meer",
    home: "Home",
    manager_side: "Beheer",

    // Settings
    admin_label: "Beheer",
    settings_owner_desc: "Beheer je bedrijfsgegevens, privacy en uitnodigingen.",
    settings_readonly: "Alleen de eigenaar kan instellingen wijzigen.",
    company_data: "Bedrijfsgegevens",
    company_data_desc: "Naam, sector en tijdzone zoals ze in de app verschijnen.",
    sector: "Sector", timezone_label: "Tijdzone",
    default_language: "Standaardtaal", team_size: "Teamgrootte",
    saving: "Opslaan…",
    company_saved: "Bedrijfsgegevens opgeslagen",
    settings_saved: "Instellingen opgeslagen",
    privacy_label: "Privacy",
    privacy_desc: "Bepaal wat werknemers van elkaar te zien krijgen in de directory.",
    show_phone: "Telefoonnummer tonen", show_email: "E-mailadres tonen",
    show_dept: "Afdeling tonen", show_title: "Functie tonen",
    show_birthday: "Verjaardag tonen",
    show_birthday_hint: "Werknemers zien de dag/maand als aan",
    hide_birthyear: "Geboortejaar verbergen",
    hide_birthyear_hint: "Aanbevolen: alleen dag/maand tonen — leeftijd blijft privé",
    invitations: "Uitnodigingen",
    invitations_desc: "Wie mag werknemers uitnodigen en hoe lang codes geldig zijn.",
    managers_invite: "Managers mogen uitnodigen",
    teamleads_invite: "Teamleiders mogen uitnodigen",
    codes_expire: "Codes verlopen na (dagen)",
    save_privacy_invitations: "Privacy & Uitnodigingen opslaan",

    // DesktopOnly
    desktop_only_title: "Sorry, dit werkt alleen op de site.",
    desktop_only_manager: "Roosters maken, medewerkers beheren en aanvragen goedkeuren doe je op je computer of tablet. Zo hou je écht overzicht.",
    desktop_only_employee: "Deze pagina is alleen beschikbaar op desktop.",
    view_notifications: "Bekijk meldingen",
    go_to_profile: "Ga naar profiel",
    desktop_tip: "Tip: open Rostr in een browser op je laptop of open deze site in de desktop-modus van je mobiele browser.",

    // AuthCallback
    google_linking: "Google-account koppelen…",
    google_wait: "Een moment geduld terwijl we je account inrichten.",
    login_failed: "Aanmelden niet gelukt",
    no_session: "Geen sessie ontvangen van Google.",
    back_to_login: "Terug naar login",
    company_created_toast: "Bedrijf {name} aangemaakt",
    logged_in_google: "Ingelogd via Google",

    profile_subtitle: "Beheer je gegevens en voorkeuren.",
    profile_section_data: "Gegevens",
    profile_section_prefs: "Voorkeuren",
    profile_readonly_hint: "Je persoonsgegevens staan hier alleen ter informatie. Kloppen ze niet? Vraag je manager of teamleider om ze aan te passen.",
    language: "Taal",
    // ---------- Payroll (manager + owner) ----------
    payroll_label: "Loonoverzicht",
    // ---------- Header additions (Feb 2026) ----------
    search: "Zoeken",
    cmdk_placeholder: "Zoek pagina's, medewerkers, diensten…",
    cmdk_coming_soon: "Global search — komt er snel aan ✨",
    cmdk_section_pages: "Pagina's",
    cmdk_section_actions: "Acties",
    cmdk_section_people: "Medewerkers",
    cmdk_empty: "Geen resultaten",
    cmdk_hint_navigate: "navigeer",
    cmdk_hint_open: "openen",
    cmdk_hint_results: "resultaten",
    cmdk_action_new_shift: "Nieuwe dienst",
    cmdk_action_quick_assign: "Snel toewijzen",
    cmdk_action_whats_new: "Wat is er nieuw",
    cmdk_action_toggle_theme: "Wissel donker/licht",
    swipe_hint: "Veeg naar rechts om goed te keuren, naar links om af te wijzen",
    offline_banner: "Je bent offline — laatst geladen data wordt getoond",
    whats_new: "Wat is er nieuw?",
    // ---------- Dashboard sections (Feb 2026) ----------
    section_overview: "Overzicht",
    section_personal: "Persoonlijk",
    section_planning: "Planning",
    section_team: "Team",
    section_requests: "Aanvragen",
    section_updates: "Updates",
    section_actions: "Acties",
    // ---------- Widget titles (Fase 1 — Feb 2026) ----------
    w_my_leave_balance: "Mijn verlofsaldo",
    w_my_leave_balance_desc: "Vakantiedagen — restant, goedgekeurd en aangevraagd dit jaar.",
    w_my_expected_pay: "Verwachte uitbetaling",
    w_my_expected_pay_desc: "Wat je deze maand ongeveer verdient op basis van geplande diensten.",
    w_birthdays_this_week: "Jarigen deze week",
    w_birthdays_this_week_desc: "Collega's die deze week jarig zijn.",
    w_hours_vs_contract: "Uren vs contract",
    w_hours_vs_contract_desc: "Wie zit boven, op, of onder zijn contracturen deze week.",
    hvc_over: "boven contract",
    hvc_under: "onder contract",
    planned_hours_short: "gepland",
    pending: "Aanvraag",
    payroll_page_title: "Loonoverzicht",
    payroll_page_subtitle: "Uurloon, weekend-toeslagen en totalen per medewerker — in één overzicht.",
    payroll_period_week: "Per week",
    payroll_period_month: "Per maand",
    payroll_this_week: "Deze week",
    payroll_this_month: "Deze maand",
    payroll_prev_period: "Vorige periode",
    payroll_next_period: "Volgende periode",
    payroll_grand_total: "Totaal te betalen",
    payroll_total_hours: "Netto uren",
    payroll_hours_short: "u",
    payroll_no_rate: "Geen uurloon ingesteld",
    payroll_no_rate_short: "Nog geen uurloon",
    payroll_hourly_rate: "Uurloon",
    payroll_effective_rate: "Effectief",
    payroll_multiplier: "Toeslag",
    payroll_shifts_count: "{n} diensten",
    payroll_col_shifts: "Diensten",
    payroll_no_shifts: "Geen diensten in deze periode",
    payroll_view_details: "Details",
    payroll_hide_details: "Verberg details",
    payroll_settings_title: "Toeslagen per weekdag",
    payroll_settings_desc: "Geldt voor alle medewerkers — tenzij een medewerker een eigen override heeft.",
    payroll_settings_save: "Toeslagen opslaan",
    payroll_settings_saved: "Toeslagen opgeslagen",
    payroll_rate_modal_title: "Uurloon voor {name}",
    payroll_rate_field_label: "Uurloon (€/uur)",
    payroll_rate_placeholder: "bv. 14,50",
    payroll_rate_override_toggle: "Persoonlijke toeslagen instellen (overschrijft bedrijfstoeslagen)",
    payroll_rate_override_help: "Laat een dag leeg om de bedrijfstoeslag te gebruiken.",
    payroll_rate_clear_override: "Overrides wissen",
    payroll_rate_saved: "Uurloon opgeslagen",
    payroll_edit_rate: "Uurloon bewerken",
    payroll_print: "Overzicht afdrukken",
    payroll_no_data_title: "Nog geen loongegevens",
    payroll_no_data_hint: "Stel eerst een uurloon in per medewerker. Toeslagen en totalen verschijnen dan automatisch.",
    payroll_gross_hours: "Bruto",
    payroll_pause: "Pauze",
    payroll_net: "Netto",
    payroll_amount: "Bedrag",
    payroll_period_label: "Periode",
    payroll_print_footer: "Gegenereerd op {when} · Rostr Loonoverzicht",
    dow_mon: "Ma", dow_tue: "Di", dow_wed: "Wo", dow_thu: "Do",
    dow_fri: "Vr", dow_sat: "Za", dow_sun: "Zo",
    dow_mon_full: "Maandag", dow_tue_full: "Dinsdag", dow_wed_full: "Woensdag",
    dow_thu_full: "Donderdag", dow_fri_full: "Vrijdag", dow_sat_full: "Zaterdag", dow_sun_full: "Zondag",
    // Fase 3 / 3.1 / 3.2 (Feb 2026) — Privacy matrix, individual permissions,
    // legacy notification fallback. Kept together so a future NL/EN audit
    // spots the block quickly.
    allow_emp_photo: "Medewerkers mogen een profielfoto toevoegen",
    allow_emp_photo_hint: "Standaard uit — alleen management heeft een profielfoto.",
    privacy_matrix_title: "Privacy-matrix per rol",
    privacy_matrix_desc: "Bepaal per rol welke persoonsgegevens zichtbaar zijn. Owner ziet altijd alles.",
    field: "Veld",
    privacy_field_phone: "Telefoonnummer",
    privacy_field_email: "E-mailadres",
    privacy_field_dob: "Geboortedatum",
    privacy_field_title: "Functie",
    privacy_field_dep: "Team/afdeling",
    privacy_field_photo: "Profielfoto",
    legacy_notif_gone: "Deze oudere melding kan niet meer direct worden geopend.",
    indiv_perms_title: "Individuele rechten",
    indiv_perms_desc: "Individuele instellingen overschrijven de standaardinstellingen van de rol.",
    indiv_perms_reset: "Terug naar rolstandaard",
    indiv_perms_role_default: "Rolstandaard",
    indiv_perms_state_default: "Standaard van rol",
    indiv_perms_state_allow: "Toestaan",
    indiv_perms_state_deny: "Weigeren",
    indiv_perms_invite_label: "Mag medewerkers uitnodigen",
    legacy_notif_readonly_title: "Alleen ter informatie",
    legacy_notif_readonly_body: "Deze oudere melding is alleen ter informatie. De oorspronkelijke actie kan niet meer rechtstreeks worden geopend.",

    // Fase 5 — Instellingen / Profile / Weergave
    industry_hospitality: "Horeca",
    industry_retail: "Detailhandel",
    industry_healthcare: "Zorg",
    industry_office: "Kantoor",
    industry_logistics: "Logistiek",
    industry_other: "Anders",
    industry_other_label: "Eigen sector",
    industry_other_placeholder: "Bijv. Beveiliging, Onderwijs …",
    localisation: "Lokalisatie",
    localisation_desc: "Land, tijdzone en taal van het bedrijf.",
    country_search_placeholder: "Zoek op naam of ISO-code…",
    employees_and_plan: "Medewerkers & abonnement",
    employees_and_plan_desc: "Aantal medewerkers in gebruik. De limiet komt uit je abonnement — niet uit deze pagina.",
    seat_count: "Medewerkers in gebruik",
    seats_available: "plekken vrij",
    seats_unlimited: "Onbeperkt",
    company_size_label: "Bedrijfsgrootte (informatief)",
    company_size_hint: "Alleen metadata — bepaalt geen limiet.",
    theme_light: "Licht",
    theme_dark: "Donker",
    theme_system: "Systeem",
    codes_expire_hint: "Na deze periode blokkeert een niet-geclaimde code zichzelf. Geclaimde accounts blijven altijd actief.",
    personal_settings: "Persoonlijke voorkeuren",
    personal_settings_desc: "Thema, taal en meldingen beheer je in je profiel.",
    personal_settings_link_hint: "Ga naar je profielpagina om taal en thema te wijzigen.",

    // Fase 6 — GDPR / privacy & data
    privacy_and_data: "Privacy & gegevens",
    privacy_and_data_desc: "Exporteer je eigen gegevens of verwijder je account. Owner-only voor bedrijfsacties.",
    download_my_data: "Mijn gegevens downloaden",
    download_my_data_desc: "ZIP met JSON-bestanden van je profiel, roosters, verlof, ruilverzoeken en meldingen.",
    delete_account: "Account verwijderen",
    delete_account_desc: "Persoonsgegevens worden geanonimiseerd. Historische bedrijfsadministratie blijft bewaard.",
    export_company: "Bedrijfsgegevens exporteren",
    export_company_desc: "ZIP met bedrijfsconfiguratie, medewerkers, roosters en auditlog van het laatste jaar.",
    delete_company: "Bedrijf verwijderen",
    delete_company_desc: "Plan een verwijdering in met 30 dagen bedenktijd. Alleen owners.",
    danger_zone: "Gevaarzone",
    grace_period_info: "Na bevestiging is Rostr 30 dagen niet meer bereikbaar. Binnen die periode kun je annuleren.",
    type_company_name_to_confirm: "Typ de bedrijfsnaam om te bevestigen",
    current_password: "Huidig wachtwoord",
    confirm_delete: "Definitief verwijderen",
    err_reauth_required: "Voer je wachtwoord in om te bevestigen.",
    err_invalid_password: "Verkeerd wachtwoord.",
    err_owner_delete_blocked: "Je bent de enige eigenaar — verwijder eerst het bedrijf.",
    err_company_delete_confirmation_invalid: "De bedrijfsnaam komt niet overeen.",
    err_company_deletion_pending: "Er staat al een verwijdering gepland.",
    err_export_rate_limited: "Te veel exports. Probeer over een uur opnieuw.",
    err_tenant_inactive: "Dit bedrijf is gepauzeerd omdat er een verwijdering gepland staat.",
    account_deleted_ok: "Je account is verwijderd.",
    company_deletion_scheduled: "Bedrijfsverwijdering ingepland voor {date}. Annuleren kan binnen 30 dagen.",
    cancel_company_deletion: "Verwijdering annuleren",
    company_deletion_cancelled: "Verwijdering geannuleerd.",
    deleted_employee: "Verwijderde medewerker",
    legal_privacy: "Privacybeleid",
    legal_terms: "Voorwaarden",
    legal_draft_banner: "Conceptversie — deze tekst wordt vóór de commerciële lancering juridisch beoordeeld.",
    legal_last_updated_label: "Laatst bijgewerkt",
    legal_last_updated_value: "Augustus 2026",
    legal_toc_title: "Inhoudsopgave",
    legal_back_home: "Terug naar Rostr",
    legal_lang_switch: "Wissel taal",
    legal_review_note: "Juridische review vereist",


    lr_page_subtitle: "Beoordeel verlofaanvragen van je team, gesplitst per status.",
    lr_tab_pending: "Openstaand",
    lr_tab_approved: "Goedgekeurd",
    lr_tab_rejected: "Afgewezen",
    lr_tab_history: "Historie",
    lr_empty_pending: "Geen openstaande aanvragen.",
    lr_empty_approved: "Geen goedgekeurde aanvragen in deze lijst.",
    lr_empty_rejected: "Geen afgewezen aanvragen.",
    lr_empty_history: "Nog geen historische aanvragen.",
    lr_col_employee: "Medewerker",
    lr_col_type: "Type",
    lr_col_period: "Periode",
    lr_col_days: "Dagen",
    lr_col_status: "Status",
    lr_col_location: "Locatie",
    lr_col_team: "Team",
    lr_action_approve: "Goedkeuren",
    lr_action_reject: "Afwijzen",
    // Fase 6.5A — sick decide-modal UX. Kort administratief notitieveld met
    // strikte 250-cap en expliciete waarschuwing dat medische inhoud NIET
    // hierin thuishoort. Backend dwingt cap ook af (canonical).
    lr_sick_note_label: "Administratieve opmerking",
    lr_sick_note_help: "Vul geen diagnose, symptomen, oorzaak, behandeling, medicatie of andere medische informatie in.",
    lr_sick_note_counter: "{count}/250",
    lr_sick_note_optional_placeholder: "Bijvoorbeeld: opvolging via HR gepland.",
    lr_note_optional_label: "Notitie (optioneel)",
    lr_confirm_approve: "Goedkeuren",
    lr_confirm_reject: "Afwijzen",
    lr_confirm_cancel: "Annuleren",
    lr_modal_title_approve_sick: "Ziekmelding goedkeuren",
    lr_modal_title_reject_sick: "Ziekmelding afwijzen",
    lr_modal_title_approve: "Aanvraag goedkeuren",
    lr_modal_title_reject: "Aanvraag afwijzen",
    rep_stats_title: "Live statistieken",
    rep_stats_desc: "Volgt exact de actieve filters — periode, medewerker, team, locatie, type en status.",
    rep_stat_total: "Aanvragen",
    rep_stat_approved: "Goedgekeurd",
    rep_stat_rejected: "Afgewezen",
    rep_stat_pending: "Openstaand",
    rep_stat_sick_reports: "Verzuimmeldingen",
    rep_stat_sick_employees: "Zieke medewerkers",
    rep_stat_sick_days: "Verzuimdagen",
    rep_results_title: "Resultaten",
    rep_results_desc: "Alle aanvragen die binnen de actieve filters vallen. Aantal dagen = alleen dagen binnen de gekozen periode.",
    rep_results_empty: "Geen resultaten voor deze filters.",
    rep_results_error: "Kon rapport niet laden. Probeer opnieuw.",
    rep_loading: "Bezig met laden…",
    rep_filter_type: "Type verlof",
    rep_filter_status: "Status",
    rep_filter_employee: "Medewerker",
    rep_leave_title: "Verlof & verzuim",
    rep_leave_desc: "Rapportage over verlof- en verzuimregistratie binnen de gekozen periode.",
    rep_col_employee: "Medewerker",
    rep_col_type: "Type",
    rep_col_period: "Periode",
    rep_col_days_in_period: "Dagen in periode",
    rep_col_status: "Status",
    rep_col_team: "Team",
    rep_col_location: "Locatie",
    status_pending: "Openstaand",
    status_approved: "Goedgekeurd",
    status_rejected: "Afgewezen",
  },

};

// English (source of truth for keys). We keep NL as fallback, but merge EN in.
dict.en = {
  reports_label: "Rapportages",
  reports_page_title: "Rapportages",
  reports_page_subtitle: "Exporteer uren en roosters als CSV voor analyse in Excel.",
  timesheets_report: "Urenrapportage",
  timesheets_report_desc: "Goedgekeurde (of alle) ingediende uren per medewerker voor de gekozen periode.",
  shifts_report: "Roosterrapportage",
  shifts_report_desc: "Alle geplande diensten per periode, met medewerker, locatie en team.",
  download_csv: "Download CSV",
  from_date: "Vanaf",
  until_date: "Tot",
  approved: "Goedgekeurd",
  pending: "In behandeling",
  rejected: "Afgewezen",
  billing_plan: "Plan",
  plan_starter_monthly: "Starter · Maandelijks",
  plan_team_monthly: "Team · Maandelijks",
  plan_business_monthly: "Business · Maandelijks",
  plan_scale_monthly: "Scale · Maandelijks",
  country_nl: "🇳🇱 Nederland",
  country_be: "🇧🇪 België",
  timesheets_report: "Timesheet report",
  timesheets_report_desc: "Approved (or all) submitted hours per employee for the chosen period.",
  shifts_report: "Schedule report",
  shifts_report_desc: "All planned shifts per period, with employee, location and team.",
  download_csv: "Download CSV",
  report_downloaded: "Report downloaded",
  billing_label: "Billing",
  billing_page_title: "Subscription",
  billing_page_subtitle_owner: "Manage your Rostr subscription, payment methods and invoices.",
  billing_page_subtitle_view: "See the status of your team's Rostr subscription.",
  billing_status_trial: "Free trial",
  billing_status_active: "Active",
  billing_status_past_due: "Payment due",
  billing_status_cancelled: "Cancelled",
  billing_status_expired: "Expired",
  billing_status_unpaid: "No subscription yet",
  paywall_banner_title: "Feel free to explore — but nothing works without a plan",
  paywall_banner_body: "You can browse the app but you cannot create or edit anything. Adding employees, building rosters, requesting leave, sending invites — all disabled until you pick a plan. Only you as Eigenaar can fix this.",
  paywall_choose_plan: "Pick a plan now",
  welcome_eyebrow: "Your company is created",
  welcome_title_named: "Welcome to Rostr, {name}.",
  welcome_title_plain: "Welcome to Rostr.",
  welcome_intro_p1: "Rostr runs your entire workforce scheduling: from building rosters and approving time off to logging hours and preparing payroll — for teams of 2 to 500 people.",
  welcome_intro_p2: "Your company is set up and completely empty — no employees, no locations, no shifts yet. Once you pick a plan you can set everything up yourself and start immediately.",
  welcome_f1_title: "Smart roster",
  welcome_f1_desc: "Drag shifts, copy weeks, publish with one click — with templates and recurring shifts.",
  welcome_f2_title: "Leave requests",
  welcome_f2_desc: "Employees request, you approve. Notifications by email and in-app — no more scattered chats.",
  welcome_f3_title: "Shift swaps",
  welcome_f3_desc: "Colleagues swap among each other — with or without manager approval; you set the rules.",
  welcome_f4_title: "Employees & locations",
  welcome_f4_desc: "Unlimited employees, teams and locations. Roles: Eigenaar, Manager, Team lead and Employee.",
  welcome_f5_title: "Reports & payroll",
  welcome_f5_desc: "Hours per week, contract vs scheduled, CSV exports and a payroll overview for your accountant.",
  welcome_f6_title: "Granular permissions",
  welcome_f6_desc: "Give team leads exactly the rights they need — per location or per task.",
  welcome_f7_title: "Notifications",
  welcome_f7_desc: "Roster published, leave decided, shift swapped — everyone knows instantly.",
  welcome_f8_title: "Documents",
  welcome_f8_desc: "Contracts, protocols and safety documents in one place — shared with whom you want.",
  welcome_f9_title: "Handbook & support",
  welcome_f9_desc: "A role-specific handbook inside the app plus personal support via rosterhelp@gmail.com.",
  welcome_decide_eyebrow: "One more step",
  welcome_decide_title: "Ready to use Rostr with your team?",
  welcome_decide_body: "Pick a plan and start setting things up. From € 12.99 per month for the whole company — only the owner pays.",
  welcome_cta_yes: "Yes, choose a plan",
  welcome_cta_later: "Not now — I want to look around first",
  welcome_pick_now: "Pick this plan",
  welcome_later_hint: "Feel free to browse, but without an active subscription you cannot create or edit anything. The app only fully works once you pick a plan.",
  waiting_banner_body: "Your company is waiting for an active subscription. Once the owner picks a plan you can edit shifts and leave again.",
  plan_best_for_starter_monthly: "Best for: small team, single location",
  plan_best_for_team_monthly: "Best for: hospitality & retail with 1-2 locations",
  plan_best_for_business_monthly: "Best for: multi-location or a chain",
  plan_best_for_scale_monthly: "Best for: large organisation or scale-up",
  plan_feat_starter_monthly_1: "Up to 15 employees",
  plan_feat_starter_monthly_2: "1 location, unlimited teams",
  plan_feat_starter_monthly_3: "Roster, leave & shift swaps",
  plan_feat_starter_monthly_4: "Email support",
  plan_feat_team_monthly_1: "Up to 40 employees",
  plan_feat_team_monthly_2: "1-2 locations with scoping",
  plan_feat_team_monthly_3: "Templates + recurring shifts",
  plan_feat_team_monthly_4: "Payroll overview & CSV export",
  plan_feat_business_monthly_1: "Up to 100 employees",
  plan_feat_business_monthly_2: "Unlimited locations + granular permissions",
  plan_feat_business_monthly_3: "Documents & reports",
  plan_feat_business_monthly_4: "Priority email support",
  plan_feat_scale_monthly_1: "Up to 500 employees",
  plan_feat_scale_monthly_2: "Multi-location & chain tooling",
  plan_feat_scale_monthly_3: "SSO-ready (Google & Microsoft)",
  plan_feat_scale_monthly_4: "Onboarding call + SLA",
  billing_trial_title: "Free trial",
  billing_current_title: "Current subscription",
  billing_trial_days_left: "{n} days left — pick a plan whenever you're ready.",
  billing_trial_expired_hint: "Your trial is over — pick a plan below to reactivate your team.",
  billing_plan: "Plan",
  billing_renews_on: "renews on",
  billing_manage: "Manage",
  billing_manage_title: "Manage subscription",
  billing_manage_desc: "View invoices, update your payment method, or pause/cancel your subscription via the secure Stripe portal.",
  billing_open_portal: "Open Stripe portal",
  billing_cancel_subscription: "Cancel subscription",
  billing_cancel_confirm_title: "Cancel your subscription?",
  billing_cancel_confirm_body: "You'll be redirected to Stripe to finalise the cancellation. Your team keeps access until the end of the current billing period.",
  billing_cancel_confirm_cta: "Yes, continue",
  billing_locked_title: "Rostr is locked",
  billing_locked_body: "The trial is over and there is no active subscription. Managers and employees see this message until the Eigenaar picks a plan.",
  profile_section_data: "Details",
  profile_section_prefs: "Preferences",
  billing_choose_plan: "Choose your plan",
  billing_recommended: "Recommended",
  billing_per_month: "per month",
  billing_up_to_x_employees: "Up to {n} employees",
  billing_range_employees: "{min}–{max} employees",
  billing_unlimited_employees: "Unlimited employees",
  billing_all_features: "All features included",
  billing_email_support: "Email support",
  billing_start_plan: "Start plan",
  billing_custom_eyebrow: "More than 500 employees?",
  billing_custom_title: "Custom plan",
  billing_custom_desc: "Need more than 500 employees, extra roles, integrations or an SLA? Email us — we'll tailor a plan for your organisation.",
  billing_custom_cta: "Request custom plan",
  billing_all_plans: "All plans",
  billing_current_plan: "Current",
  billing_switch_to_plan: "Switch to this plan",
  billing_not_owner_hint: "Only the Eigenaar of your company can change the subscription.",
  billing_confirming: "Confirming payment…",
  billing_confirming_hint: "Hold on — Stripe is finalising the payment.",
  billing_paid_title: "Payment successful",
  billing_paid_body: "Your subscription is active. You can use Rostr fully again.",
  billing_back: "Back to Billing",
  billing_confirm_failed: "Confirmation is taking too long",
  billing_cancel_title: "Payment cancelled",
  billing_cancel_body: "Nothing has been charged. You can try again anytime.",
  trial_banner_days_left: "{n} days left in your free trial",
  trial_banner_last_day: "Last day of trial — start your subscription today",
  trial_banner_locked: "Trial expired — Rostr is locked until the Eigenaar picks a plan",
  trial_banner_cta: "Go to Billing",
  app_name: "Rooster", tagline: "Workforce scheduling that ships.",
  login_title: "Sign in to your account", login_subtitle: "Manage your schedule, leave and hours.",
  email: "Email", password: "Password", login: "Sign in", logout: "Sign out",
  logging_in: "Signing in...", demo_accounts: "Demo accounts", forgot_password: "Forgot password?",
  // Fase 6.5B — forced Terms/Privacy acceptance screen strings (EN).
  legal_title_first: "Review and accept the Terms",
  legal_title_updated: "Terms updated",
  legal_title_privacy_updated: "Privacy Policy updated",
  legal_title: "Review and accept the Terms",
  legal_intro: "Before you can continue in Rostr, please take a moment to review and confirm the latest Terms and Privacy Policy.",
  legal_current_version: "Current version",
  legal_current_terms_version: "Current Terms version",
  legal_current_privacy_version: "Current Privacy Policy version",
  // Never phrase the Privacy Notice as consent — it's a transparency
  // document under GDPR art. 13/14, not a lawful basis on its own.
  legal_terms_checkbox_prefix: "I agree to the",
  legal_terms_link: "Terms",
  legal_terms_checkbox_suffix: ".",
  legal_privacy_checkbox_prefix: "I confirm that I have been able to read the",
  legal_privacy_link: "Privacy Policy",
  legal_privacy_checkbox_suffix: ".",
  legal_terms_already_accepted: "Terms already accepted.",
  legal_privacy_already_seen: "Privacy Policy already acknowledged.",
  // Legacy aliases to keep older tests working.
  legal_terms_checkbox: "I agree to the",
  legal_privacy_checkbox: "I confirm that I have been able to read the",
  legal_submit: "Confirm and continue",
  legal_accept_success: "Thanks for confirming.",
  legal_version_outdated: "The Terms have just been updated. Please review the latest version and confirm again.",
  legal_loading: "One moment…",
  legal_error: "Something went wrong. Please try again.",
  legal_logout: "Sign out",
  legal_version_label: "Version",
  legal_status_error_title: "Session status not verified",
  legal_status_error_body: "We couldn't verify your session status. Please try again.",
  legal_status_error_retry: "Try again",
  welcome_good_morning: "Good morning",
  welcome_good_afternoon: "Good afternoon",
  welcome_good_evening: "Good evening",
  welcome_back_name: "Welcome back, {firstName}",
  welcome_back_generic: "Welcome back",
  welcome_summary_intro: "Here's what needs your attention right now.",
  welcome_first_use_intro: "Here's what needs your attention right now.",
  welcome_since_last_visit_intro: "Here's what changed since your last visit.",
  welcome_view_summary: "View overview",
  welcome_skip_now: "Skip for now",
  welcome_close: "Close",
  welcome_missed_title: "What did you miss?",
  welcome_missed_subtitle: "Here's what changed since your last visit.",
  welcome_first_use_title: "Here's what's on your plate.",
  welcome_first_use_subtitle: "Here's what needs your attention right now.",
  welcome_all_caught_up: "You're all caught up.",
  welcome_no_updates: "There are no important new updates since your last visit.",
  welcome_go_to_rostr: "Go to Rostr",
  welcome_back_button: "Back",
  welcome_step_of: "{a} of {b}",
  welcome_group_new: "New since your last visit",
  welcome_group_outstanding: "Still outstanding",
  welcome_unread_notifications: "{n} unread notifications",
  welcome_pending_leave: "{n} leave requests pending",
  welcome_pending_swaps: "{n} swap requests pending",
  welcome_pending_time: "{n} time approvals to review",
  welcome_open_shifts: "{n} open shifts",
  welcome_shifts_this_week: "{n} shifts this week",
  welcome_my_shifts_today: "{n} of your shifts today",
  welcome_my_shifts_week: "{n} of your shifts this week",
  welcome_pending_own_leave: "{n} of your leave requests pending",
  welcome_claimable_shifts: "{n} claimable shifts",
  welcome_new_notifications: "{n} new notifications",
  welcome_new_leave_requests: "{n} new leave requests",
  welcome_new_swap_requests: "{n} new swap requests",
  welcome_new_time_submissions: "{n} new time submissions",
  welcome_new_open_shifts: "{n} new open shifts",
  welcome_new_own_leave_decided: "{n} decisions on your leave requests",
  welcome_new_swap_offers: "{n} new swap offers for you",
  welcome_new_my_shifts: "{n} new shifts for you",
  settings_welcome_summary_label: "Welcome summary after sign-in",
  settings_welcome_summary_description: "Show a short greeting and a summary of what you missed after signing in. This preference is personal — it only applies to you.",
  // Fase 6.5C — CSRF-invalid toast copy. Never mention "CSRF" to end users.
  csrf_invalid_toast: "Your secure session could not be verified. Refresh the page and try again.",
  // Phase 8.1 — email verification gate + verify page copy.
  verify_email_title: "Check your email",
  verify_email_check_body: "We sent you a verification link. Click the button in that email to activate your account. The link is valid for 24 hours.",
  verify_email_resend: "Resend email",
  verify_email_resend_success: "We sent a new verification link.",
  verify_email_rate_limited: "You already requested a verification email recently. Please try again later.",
  verify_email_resend_wait: "Wait",
  verify_email_logout: "Sign out",
  verify_email_wrong_email_hint: "Wrong address? Sign out and try again with the correct account.",
  verify_email_check_again: "I've confirmed",
  verify_email_verifying: "Verifying...",
  verify_email_success: "Your email is verified",
  verify_email_success_body: "Thanks! Your account is now fully activated. Continue to Rostr.",
  verify_email_success_body_authed: "Your email address has been verified. Redirecting to Rostr…",
  verify_email_success_body_unauth: "Your email address has been verified.",
  verify_email_redirecting: "Redirecting…",
  verify_email_continue_to_rostr: "Continue to Rostr",
  verify_email_continue: "Continue to Rostr",
  verify_email_invalid: "Link invalid or expired",
  verify_email_invalid_body: "This verification link no longer works. Request a new one from your Rostr account.",
  verify_email_back_to_resend: "Back to Rostr",
  verify_email_back_to_login: "Back to sign in",
  verify_email_status_verified: "Email address verified",
  verify_email_status_unverified: "Email address not yet verified",
  email_verification_required: "Please verify your email address to continue.",
  // Phase 8.2 — Security section + MFA copy.
  security_title: "Security",
  security_email_label: "Email address",
  security_email_verified: "Verified",
  security_email_unverified: "Not verified",
  security_mfa_label: "Two-factor authentication",
  security_mfa_on: "Enabled",
  security_mfa_off: "Disabled",
  security_mfa_desc_on: "Every sign-in requires a 6-digit code from your authenticator app.",
  security_mfa_desc_off: "Add an extra layer of security with an authenticator app.",
  security_enable_mfa: "Enable",
  security_disable_mfa: "Disable",
  security_regenerate_recovery: "Regenerate recovery codes",
  mfa_enable_title: "Enable two-factor authentication",
  mfa_enable_password_prompt: "Confirm your password to continue.",
  mfa_scan_title: "Scan the QR code",
  mfa_scan_subtitle: "Open your authenticator app (Google Authenticator, 1Password, Authy...) and scan the QR code. Can't scan? Enter the key below manually.",
  mfa_scan_manual_key: "Manual key",
  mfa_verify_title: "Confirm with your 6-digit code",
  mfa_verify_subtitle: "Enter the code your authenticator app is showing right now.",
  mfa_enable_confirm: "Enable",
  mfa_recovery_title: "Save your recovery codes",
  mfa_recovery_subtitle_new: "You'll see these codes only once. Save them somewhere safe — you'll need them if you lose access to your phone.",
  mfa_recovery_subtitle_regen: "Your old recovery codes no longer work. Save these new codes safely.",
  mfa_recovery_done: "I've saved them",
  mfa_recovery_warning: "Each code works only once.",
  mfa_disable_description: "Confirm your password to disable two-factor authentication.",
  mfa_disable_success: "Two-factor authentication has been disabled.",
  mfa_regenerate_description: "Confirm your password to generate a fresh set of recovery codes. Your old codes will stop working immediately.",
  mfa_password_wrong: "Incorrect password.",
  mfa_code_wrong: "That code isn't right. Please try again.",
  login_mfa_title: "Two-factor authentication",
  login_mfa_subtitle: "Enter the 6-digit code shown in your authenticator app.",
  login_mfa_placeholder: "123456",
  login_mfa_submit: "Verify",
  login_mfa_use_recovery: "Use recovery code",
  login_mfa_use_totp: "Back to code",
  login_mfa_recovery_placeholder: "XXXXX-XXXXX",
  login_mfa_error: "Verification failed. Please try again.",
  login_mfa_rate_limited: "Too many attempts. Try again in a few minutes.",
  copy_all: "Copy all",
  copied: "Copied",
  download_txt: "Download .txt",
  back: "Back",
  continue: "Continue",
  cancel: "Cancel",
  password: "Password",
  error: "Something went wrong. Please try again.",
  dashboard: "Dashboard", roster: "Schedule", employees: "Employees", locations: "Locations",
  teams: "Teams", leave_requests: "Leave requests", swap_requests: "Shift swaps",
  time_approvals: "Timesheet approvals", notifications: "Notifications", news: "News",
  my_roster: "My schedule", my_leave: "My leave", my_availability: "Availability",
  // Phase 9B.3a — Employee mobile agenda kick-off
  next_shift_eyebrow: "Next shift",
  next_shift_today_eyebrow: "Today",
  my_swaps: "My swaps", profile: "Profile", settings: "Settings",
  new: "New", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit",
  approve: "Approve", reject: "Reject", accept: "Accept", decline: "Decline",
  publish: "Publish", publish_week: "Publish week", open_shifts: "Open shifts",
  total_employees: "Employees", open_shifts_stat: "Open shifts",
  pending_leave: "Pending leave", pending_swaps: "Pending swaps",
  pending_time: "Timesheets to review", shifts_this_week: "Shifts this week",
  today: "Today", week: "Week", day: "Day", prev: "Previous", next: "Next",
  from: "From", to: "To", date: "Date", start: "Start", end: "End",
  role: "Role", role_label: "Position", location: "Location", team: "Team",
  employee: "Employee", unassigned: "Unassigned", status: "Status",
  draft: "Draft", published: "Published", pending: "Pending",
  approved: "Approved", rejected: "Rejected", accepted: "Accepted",
  declined: "Declined", cancelled: "Cancelled",
  add_employee: "Add employee", add_location: "Add location",
  add_team: "Add team", add_shift: "Add shift",
  request_leave: "Request leave", request_swap: "Request swap",
  submit_hours: "Submit hours",
  reason: "Reason", manager_note: "Manager note", message: "Message",
  name: "Name", phone: "Phone", language: "Language", address: "Address", city: "City",
  color: "Color", description: "Description", mark_all_read: "Mark all read",
  landing_eyebrow: "Workforce scheduling",
  demo_hint: "tap to prefill",
  no_data: "No data yet.", saved: "Saved", error: "Something went wrong",
  hours_col: "Hours", hours_this_week: "this week",
  hvc_badge_on: "on contract", hvc_badge_over: "over contract", hvc_badge_under: "under contract",
  ok_leave_submitted: "Leave requested",
  ok_swap_submitted: "Swap request sent",
  ok_profile_saved: "Profile saved",
  ok_permissions_saved: "Permissions saved",
  confirm_delete: "Are you sure you want to delete this?",
  confirm_delete_title: "Are you sure?",
  confirm_delete_loc_body: "Location \"{name}\" will be permanently deleted. Shifts and teams linked to this location will lose that reference. This cannot be undone.",
  confirm_delete_team: "Team \"{name}\" will be deleted. Existing shifts with this team will remain but lose the team link.",
  confirm_delete_employee: "Employee \"{name}\" will be deleted. Their account will be deactivated and future shifts become unassigned.",
  confirm_delete_document: "Document \"{title}\" will be permanently deleted. This cannot be undone.",
  confirm_delete_shift: "This shift will be deleted. You have 5 seconds to undo.",
  undo: "Undo",
  copied: "Copied",
  shift_deleted: "Shift deleted",
  team_deleted: "Team deleted",
  employee_deleted: "Employee deleted",
  document_deleted: "Document deleted",
  ical_export: "Export to Calendar (.ics)",
  ical_downloaded: "Roster downloaded",
  invite_modal_eyebrow: "Invitation",
  invite_modal_title: "Share this code with your colleague",
  invite_modal_role: "Role",
  invite_code_label: "6-letter code",
  invite_scan_hint: "Scan with camera",
  invite_scan_desc: "The new colleague scans this QR code with their phone to open the join page instantly.",
  invite_copy_url: "Copy link",
  invite_share: "Share",
  invite_share_title: "Join our roster",
  invite_share_text: "Use code {code} to join our team on Rostr.",
  open_to_anyone: "Open to anyone",
  // Documents page
  // Documents page — Phase 7.2 storage-backed module.
  docs_page_title: "Documents",
  docs_subtitle_mgmt: "Manage policies, protocols and internal documents.",
  docs_subtitle_employee: "See the documents that are available to you.",
  docs_new_document: "New document",
  docs_new_version: "Upload new version",
  docs_search_placeholder: "Search by title...",
  docs_filter_category: "Category",
  docs_filter_status: "Status",
  docs_filter_visibility: "Visibility",
  docs_filter_ack: "Acknowledgement",
  docs_filter_all: "All",
  docs_filter_action_required: "Action required",
  docs_filter_ack_yes: "Acknowledgement required",
  docs_filter_ack_no: "No acknowledgement",
  docs_cat_policy: "Policy",
  docs_cat_safety: "Safety",
  docs_cat_procedure: "Procedure",
  docs_cat_handbook: "Handbook",
  docs_cat_hr: "HR",
  docs_cat_employee_document: "Employee document",
  docs_cat_other: "Other",
  docs_status_draft: "Draft",
  docs_status_published: "Published",
  docs_status_archived: "Archived",
  docs_status_superseded: "Superseded",
  docs_status_current: "Current version",
  docs_vis_company: "Whole organization",
  docs_vis_location: "Location",
  docs_vis_team: "Team",
  docs_vis_selected_users: "Selected employees",
  docs_vis_employee_private: "Personal employee document",
  docs_col_document: "Document",
  docs_col_category: "Category",
  docs_col_version: "Version",
  docs_col_visibility: "Visibility",
  docs_col_updated: "Updated",
  docs_col_status: "Status",
  docs_col_actions: "Actions",
  docs_upload_choose_file: "Choose a file",
  docs_upload_selected_file: "Selected file",
  docs_upload_title_field: "Title",
  docs_upload_desc_field: "Description",
  docs_upload_desc_optional: "Optional",
  docs_upload_category_field: "Category",
  docs_upload_visibility_field: "Visibility",
  docs_upload_require_ack: "Requires acknowledgement",
  docs_upload_pick_location: "Choose one or more locations",
  docs_upload_pick_team: "Choose one or more teams",
  docs_upload_pick_users: "Choose one or more employees",
  docs_upload_pick_subject: "Choose employee",
  docs_upload_max_size: "Max {n} MB per file.",
  docs_upload_supported_types: "PDF, DOCX, XLSX, PNG, JPG, TXT, CSV.",
  docs_upload_uploading: "Uploading...",
  docs_upload_save_draft: "Save as draft",
  docs_upload_publish_now: "Publish",
  docs_upload_saved_draft: "Draft saved.",
  docs_upload_version_saved: "Version {n} saved as a draft.",
  docs_upload_error_type: "File type not allowed.",
  docs_upload_error_too_large: "File is too large (max {n} MB).",
  docs_upload_error_generic: "Upload failed.",
  docs_publish_confirm_title: "Publish version?",
  docs_publish_confirm_body: "This version becomes visible to employees.",
  docs_publish_confirm_reack: "Employees who can see this document must acknowledge this version again.",
  docs_publish_success: "Version published.",
  docs_publish_failed: "Publish failed.",
  docs_archive_confirm_title: "Archive document?",
  docs_archive_confirm_body: "This document will no longer be shown to employees.",
  docs_archived_success: "Archived.",
  docs_delete_confirm_title: "Delete document permanently?",
  docs_delete_confirm_body: "All versions and acknowledgements of this document will be permanently deleted.",
  docs_delete_confirm_typed: "Type the title to confirm:",
  docs_delete_success: "Document deleted.",
  docs_delete_failed: "Delete failed. Please try again.",
  docs_delete_owner_only: "Only the owner can permanently delete.",
  docs_download: "Download",
  docs_downloading: "Opening...",
  docs_download_failed: "Could not open file.",
  docs_ack_button: "I have read this document",
  docs_ack_confirm_title: "Acknowledge",
  docs_ack_confirm_body: "I confirm that I have read this document.",
  docs_ack_success: "Acknowledged.",
  docs_ack_already: "You have already acknowledged this version.",
  docs_acked_status: "Acknowledged",
  docs_ack_matrix_title: "Acknowledgements",
  docs_ack_matrix_summary: "{done} of {total} acknowledged",
  docs_ack_matrix_none: "Nobody has acknowledged this version yet.",
  docs_ack_matrix_pending_none: "Everyone has acknowledged this version.",
  docs_ack_pending: "Not acknowledged",
  docs_ack_at: "Acknowledged at",
  docs_versions_title: "Version history",
  docs_version_label: "Version {n}",
  docs_versions_empty: "No versions yet. Upload the first file to get started.",
  docs_meta_created: "Created",
  docs_meta_updated: "Updated",
  docs_meta_uploaded_by: "Uploaded by",
  docs_meta_file_size: "File size",
  docs_meta_content_type: "File type",
  docs_meta_current_version: "Current version",
  docs_meta_latest_version: "Latest uploaded",
  docs_meta_never_published: "Not published yet",
  docs_meta_no_current: "No published version yet",
  docs_empty_owner_title: "No documents yet",
  docs_empty_owner_body: "Upload a policy, protocol or other internal document to get started.",
  docs_empty_employee_title: "No documents available",
  docs_empty_employee_body: "There are no documents for you at the moment.",
  docs_empty_action_required: "You're all caught up.",
  docs_section_action_required: "Action required",
  docs_section_available: "Available to you",
  docs_section_personal: "Personal documents",
  docs_disabled_title: "Documents are not available",
  docs_disabled_body: "This module is not enabled for your organization.",
  docs_storage_unavailable_title: "Documents are temporarily unavailable",
  docs_storage_unavailable_body: "Please try again later.",
  docs_forbidden: "No access to this document.",
  docs_not_found: "Document not found.",
  docs_close: "Close",
  docs_open_detail: "Open",
  docs_toolbar_reset: "Clear filters",
  docs_visibility_summary: "Visible to: {who}",
  docs_by_uploader: "by {name}",
  // Welcome integration.
  welcome_documents_pending_ack: "{n} outstanding document acknowledgements",
  welcome_new_documents_published: "{n} newly published documents",
  // Notification copy.
  notif_document_ack_required_title: "A new document requires your attention.",
  notif_document_ack_required_body: "There is a new document waiting for you.",
  search_placeholder: "Search...",
  emp_search_placeholder: "Search by name, function or department…",
  invite_code_action: "Invite code",
  invite_short: "Invite",
  // Playful empty states
  empty_roster_title: "Another quiet day ✈️",
  empty_roster_hint: "Tap the + button to add your first shift for this day.",
  empty_notifs_title: "All quiet here ✨",
  empty_notifs_hint: "New notifications will land in your screen automatically.",
  empty_news_title: "No news to share yet",
  empty_news_hint: "Be the first to share something with the team — a tip, a success or just a good morning.",
  empty_leaves_title: "No leave requests",
  empty_leaves_hint: "When someone requests time off you'll see it appear here.",
  empty_swaps_title: "No open swap requests",
  empty_swaps_hint: "You can only request a swap once you have a shift. Come back later.",
  empty_timesheets_title: "All hours are handled",
  empty_timesheets_hint: "As soon as someone clocks hours they show up here for review.",
  empty_search_title: "Nothing found",
  empty_search_hint: "Try a different search or adjust the filters.",
  empty_generic_title: "It's empty here for now",
  empty_generic_hint: "Add something to get started, or come back later.",
  clear_search: "Clear search",
  // Pause settings extras
  enabled_label: "Enabled",
  disabled_label: "Disabled — pauses filled in manually",
  pause_mode_title: "Calculation method",
  pause_mode_hint: "Choose how Rostr determines the pause.",
  pause_config_title: "Configure rules",
  pause_config_hint_flat: "Shifts at or above the threshold get a fixed pause.",
  pause_config_hint_tiered: "Add tiers: longer shifts get longer pauses.",
  pause_warning_title: "Low-pause warning",
  pause_warning_hint: "Get a warning if the entered pause seems too short for the shift length.",
  pause_preview_title: "Live preview",
  pause_preview_desc: "How Rostr calculates the pause with your current settings.",
  hours_short: "h",
  minutes_short: "min",
  no_pause: "no pause",
  high_short: "High",
  // News / birthday
  news_hide: "Hide",
  bday_toast_sent: "🎉 Congrats sent",
  bday_toast_error: "Could not send congrats",
  bday_celebrate: "Congratulate",
  bday_celebrated: "Congratulated",
  // Trash bin
  trash_eyebrow: "Restore",
  trash_title: "Trash bin",
  trash_subtitle: "Deleted employees stay here. Restore them within 30 days or permanently delete.",
  trash_open: "Trash",
  trash_restore: "Restore",
  trash_purge: "Delete permanently",
  trash_restored: "Employee restored",
  trash_purged: "Permanently deleted",
  trash_deleted_at: "deleted on",
  trash_empty_title: "Trash is empty",
  trash_empty_hint: "Deleted employees will appear here so you can restore them.",
  trash_confirm_title: "Delete permanently?",
  trash_confirm_body: "Employee \"{name}\" will be irrecoverably deleted including email and all settings. This cannot be undone.",
  // iCal subscribe
  ical_subscribe: "Auto-sync (webcal)",
  ical_subscribe_title: "Roster live in your calendar",
  ical_subscribe_desc: "Copy the webcal link and add it to Google Calendar, Apple Calendar or Outlook. Every hour your new shifts sync automatically.",
  ical_subscribe_copy: "Copy webcal link",
  ical_url_copied: "Link copied — paste it into your calendar app",
  ical_generating: "Creating link…",
  ical_revoke: "Disable sync",
  ical_revoked: "Sync disabled",
  ical_help_google: "Google Calendar → + next to 'Other calendars' → From URL",
  ical_help_apple: "Apple Calendar → File → New Calendar Subscription",
  wn_eyebrow: "New",
  wn_title: "What's new in Rostr?",
  wn_got_it: "Let's go",
  wn_auto_pause_title: "Auto-break based on rules",
  wn_auto_pause_desc: "Set your break rules once in Settings → Break and Rostr calculates every shift automatically.",
  wn_dnd_title: "Drag shifts in the matrix",
  wn_dnd_desc: "Quickly reassign shifts by dragging them to another employee in the matrix view.",
  wn_mobile_roster_title: "Roster on your phone",
  wn_mobile_roster_desc: "Managers and team leads can now open the day-view roster on the go.",
  wn_widget_popup_title: "Widget details in one place",
  wn_widget_popup_desc: "Click any dashboard widget to see details + quick actions.",
  ocl_eyebrow: "Get started",
  ocl_title: "Finish your setup in 5 steps",
  ocl_progress: "{done} of {total} done",
  ocl_dismiss: "Later",
  ocl_step_location: "Add a location",
  ocl_step_team: "Create your first team",
  ocl_step_employees: "Invite employees",
  ocl_step_shift: "Plan your first shift",
  ocl_step_publish: "Publish your first week",
  role_owner: "Eigenaar", role_manager: "Manager", 
  role_teamlead: "Team lead", role_employee: "Employee",
  role_perm_owner: "All permissions",
  role_perm_manager: "No locations/billing",
  role_perm_teamlead: "Roster & leave",
  role_perm_employee: "Own roster",
  managed_locations_label: "Locations this manager can manage",
  managed_locations_hint: "Pick one or more locations. This manager only sees and manages roster, employees, teams and shifts within these locations.",
  managed_locations_all_selected: "No selection = access to all locations",
  managed_locations_x_selected: "{n} location(s) selected — access limited to these",
  managed_locations_none_yet: "Create locations first so you can assign them.",
  nav_new_badge: "NEW",
  time_just_now: "just now",
  time_minutes_ago: "{n} min ago",
  time_hours_ago: "{n} h ago",
  time_yesterday: "yesterday",
  time_days_ago: "{n} days ago",
  time_one_week_ago: "1 week ago",
  time_weeks_ago: "{n} weeks ago",
  time_months_ago: "{n} months ago",
  swap_requested_prefix: "Requested {ago}",
  w_team_composition: "Team composition",
  w_team_composition_desc: "Role breakdown across your company",
  team_composition_total: "people",
  loc_managers_label: "Managers at this location",
  loc_managers_none: "Nobody assigned yet. Go to Employees → edit a manager to link this location.",
  loc_managers_unscoped_tag: "all locations",
  loc_managers_unscoped_hint: "This manager oversees all locations (no scope set).",
  loc_managers_more_tooltip: "And more managers",
  // Avatar upload
  avatar_label: "Profile photo",
  avatar_upload: "Upload photo",
  avatar_replace: "Replace photo",
  avatar_remove: "Remove photo",
  avatar_saved: "Photo saved",
  avatar_removed: "Photo removed",
  avatar_hint: "Square works best · max 8 MB",
  avatar_err_type: "Only image files are allowed",
  avatar_err_size: "Image is too large (max 8 MB)",
  emp_no_name: "Unnamed",
  emp_section_personal: "Personal",
  emp_section_role: "Role & assignment",
  emp_section_scope: "Management scope",
  role_hr: "HR",
  loc_focus_hint: "Click to show only this location across the app",
  loc_focus_activated: "Focused on location '{name}'",
  loc_scope_banner: "Active location: {name}. All lists are filtered to this location.",
  loc_scope_clear: "Show all locations",
  loc_scope_cleared: "Location filter cleared",
  loc_scope_pill_all: "All locations",
  loc_scope_pill_one: "Location: {name}",
  loc_scope_switcher_label: "Quickly switch location",
  loc_scope_switcher_all: "Show all locations",
  loc_scope_reloading: "Loading data for {name}…",
  loc_scope_reloading_all: "Loading all locations…",
  loc_page_intro_title: "How location focus works",
  loc_page_intro_body: "Pick a location to filter the entire dashboard, all rosters, employee lists, teams and reports down to that location only. You can switch at any time via the blue bar at the top.",
  loc_page_intro_active: "You're currently viewing data for {name} only.",
  loc_page_intro_all: "You're currently viewing data for all locations.",
  loc_view_this: "View this location",
  loc_active_here: "Now active",
  loc_stat_employees: "employees",
  loc_stat_teams: "teams",
  payroll_edit_short: "Rate",
  payroll_actions_col: "Actions",
  shift_preview_label: "Preview",
  shift_date_missing: "Pick a date",
  shift_unassigned_label: "Not assigned yet",
  shift_section_when: "When",
  shift_section_when_hint: "Pick the date and start/end times.",
  // Fase 3.1 — Privacy matrix UI keys.
  allow_emp_photo: "Employees may upload a profile photo",
  allow_emp_photo_hint: "Default off — only management have a profile photo.",
  privacy_matrix_title: "Privacy matrix per role",
  privacy_matrix_desc: "Choose per role which personal data is visible. Owner always sees everything.",
  field: "Field",
  privacy_field_phone: "Phone",
  privacy_field_email: "Email",
  privacy_field_dob: "Date of birth",
  privacy_field_title: "Job title",
  privacy_field_dep: "Team / department",
  privacy_field_photo: "Profile photo",
  legacy_notif_gone: "This legacy notification can no longer be opened directly.",
  // Fase 3.2 — Individual permissions.
  indiv_perms_title: "Individual permissions",
  indiv_perms_desc: "Individual settings override the role defaults.",
  indiv_perms_reset: "Reset to role default",
  indiv_perms_role_default: "Role default",
  indiv_perms_state_default: "Role default",
  indiv_perms_state_allow: "Allow",
  indiv_perms_state_deny: "Deny",
  indiv_perms_invite_label: "May invite employees",
  legacy_notif_readonly_title: "For information only",
  legacy_notif_readonly_body: "This legacy notification is for information only. The original action can no longer be opened directly.",
  shift_section_who: "Who",
  shift_section_who_hint: "Assign an employee, or leave open so anyone can claim it.",
  shift_section_where: "Where",
  shift_section_where_hint: "Location and (optionally) team for this shift.",
  shift_section_details: "Details",
  shift_section_details_hint: "Role, break and notes. Optional.",
  shift_section_status: "Publication",
  shift_section_status_hint: "Publish when you're done — otherwise the shift stays as a draft.",
  shift_save_cta: "Save shift",
  shift_publish_cta: "Publish shift",
  shift_pause: "Break (min)",
  shift_pause_hint: "Empty = auto-calculated from settings",
  shift_pause_auto: "auto",
  shift_team_loc_mismatch: "This team does not belong to the selected location.",
  shift_presets_label: "Quick fill:",
  shift_preset_morning: "Morning",
  shift_preset_afternoon: "Afternoon",
  shift_preset_evening: "Evening",
  shift_preset_fullday: "Full day",
  // Phase 9B.3b1b — SideDrawer editor + sticky publish bar
  shift_save_add_another: "Save & add another",
  shift_save_add_another_hint: "Save this shift and keep the drawer open to add another one.",
  shift_conflict_preview_title: "Overlap detected",
  unpublished_changes: "unpublished changes",
  unpublished_single: "unpublished change",
  unpublished_state: "unpublished",
  open_shift_single: "open shift",
  open_needs_one: "waiting to be filled",
  open_needs_many: "waiting to be filled",
  on_leave_short: "On leave",
  unavailable_short: "Unavailable",
  assign_hint: "Assign an employee",
  empty_day: "empty",
  scheduled_single: "scheduled",
  scheduled_many: "scheduled",
  scheduled_short: "scheduled",
  conflict_short: "conflict",
  wijz_short: "chg.",
  employee_single: "employee",
  employee_many: "employees",
  open_needed_single: "needed",
  open_needed_many: "needed",
  day_agenda_empty_title: "No shifts scheduled for this day yet.",
  day_agenda_empty_hint: "Click ‘Add shift’ or tap a time in the axis to start.",
  shift_show_more: "More options",
  shift_hide_more: "Fewer options",
  shift_publish_now: "Publish immediately (employees will see this shift)",
  more: "More",
  filters_active: "Active filter",
  clear_filter: "Clear filter",
  employee_picker_search: "Search employee…",
  employee_picker_no_results: "No employee found.",
  employee_selected: "Selected",
  open_shift_label: "Open shift (no employee)",
  overlap: "Overlap",
  publish_up_to_date_hint: "All changes are already published.",
  status_fully_planned: "Fully scheduled",
  view_calendar: "Calendar",
  view_employee: "Employees",
  view_day: "Days",
  open_shift_badge: "OPEN",
  employees_plural: "employees",
  shift_single: "shift",
  shifts_plural: "shifts",
  sticky_publish_hint: "Employees still see the previously published roster.",
  // Phase 9B.3b2 — publish confirmation + extended validate-preview
  publish_confirm_title: "Publish roster?",
  publish_confirm_body: "After publishing, every affected employee will see this roster immediately. Draft shifts become visible and edits to previously published shifts are pushed live.",
  publish_failed: "Publish failed. Your draft was preserved — try again.",
  shift_preview_warnings_title: "Heads up",
  shift_preview_on_leave: "Employee has approved leave",
  shift_preview_unavailable: "Employee marked themselves unavailable",
  permissions_nav: "Permissions",
  permissions_eyebrow: "Management",
  permissions_title: "Permissions & assignments",
  permissions_subtitle: "Set who each team leader supervises and which actions they can perform.",
  permissions_empty_title: "No team leaders yet",
  permissions_empty_hint: "Create a team leader in Employees first, then come back here.",
  perm_managed_employees_label: "Manages these employees",
  perm_permissions_label: "Permissions",
  perm_all_employees: "All employees",
  perm_all_employees_hint: "This team leader sees and manages all employees within their location scope.",
  perm_x_selected: "{n} employee(s) selected — limited to these people.",
  perm_no_employees_yet: "No employees created yet.",
  perm_view_documents: "View documents",
  perm_approve_leave: "Approve leave",
  perm_approve_swaps: "Approve shift swaps",
  perm_edit_shifts: "Edit roster",
  perm_view_reports: "View reports",
  shift_single: "shift",
  shifts_plural: "shifts",
  day_empty: "Free",
  all_short: "All",
  draft_short: "Draft",
  shift_section_templates: "Template",
  shift_section_templates_hint: "Pick a saved preset or make this shift the starting point for a new one.",
  shift_template_choose: "Choose template…",
  shift_template_save: "Save as template",
  shift_template_save_hint: "Keep the current times, location and role for next time",
  shift_template_delete: "Delete template…",
  shift_template_saved: "Template saved",
  shift_template_prompt_name: "Template name (e.g. 'Weekend kitchen 08–16'):",
  shift_template_applied: "Template '{name}' applied",
  shift_template_delete_confirm: "Delete template '{name}'?",
  seat_banner_used: "seats used",
  seat_banner_ok: "You have plenty of room on your current plan.",
  seat_banner_nearly_full: "Almost full",
  seat_banner_full_title: "Your plan is full",
  seat_banner_full_hint: "Only the owner can upgrade or add more seats.",
  seat_banner_full_owner: "Upgrade to Pro for unlimited employees.",
  seat_banner_slot_one: "seat left",
  seat_banner_slot_many: "seats left",
  seat_upgrade_cta: "Upgrade",
  seat_modal_title: "Need more employees? Upgrade your plan.",
  seat_modal_body_generic: "Your current plan has reached the employee limit (incl. pending invites). Upgrade to Pro for unlimited employees.",
  seat_modal_upgrade_hint: "Pick Pro for unlimited employees and every feature.",
  seat_modal_go_billing: "Go to Billing",
  documents_label: "Documents",
  repeat_label: "Repeat",
  repeat_weekly: "Repeat weekly",
  repeat_hint: "Creates copies of this shift on the same weekday.",
  weeks_short: "weeks",
  // Auto-pause
  pause_label: "Break",
  pause_minutes_short: "min break",
  auto_label: "auto",
  pause_settings: "Break settings",
  pause_nav_label: "Breaks",
  widget_detail_eyebrow: "Widget",
  widget_detail_current: "Now",
  widget_detail_actions: "What do you want to do?",
  widget_detail_no_actions: "This widget is informational only.",
  // App onboarding (PWA first launch)
  app_onboard_1_title: "Welcome to Rostr",
  app_onboard_1_desc: "Smart scheduling for your whole team — plan, swap and communicate in one place.",
  app_onboard_2_title: "Your team, one overview",
  app_onboard_2_desc: "See who's working, who's off and who's available. Invite colleagues with a simple code.",
  app_onboard_3_title: "Never miss a thing",
  app_onboard_3_desc: "Get notified about shifts, swap requests and leave. Stay signed in — no need to log in every time.",
  app_onboard_next: "Next",
  app_onboard_start: "Get started",
  app_onboard_eyebrow: "Workforce scheduling",
  install_banner_title: "Install Rostr as an app",
  install_banner_desc: "Faster, with notifications and always available from your home screen.",
  install_banner_ios_pre: "Tap",
  install_banner_ios_mid: "and choose",
  install_banner_ios_add: "Add to Home Screen",
  pause_settings_desc: "Automatically add break minutes to long shifts based on duration.",
  pause_desktop_only_hint: "Only configurable on the website.",
  auto_pause_enabled: "Enable auto-break",
  auto_pause_enabled_hint: "Add a break automatically when creating a shift.",
  pause_mode_flat: "Flat rule",
  pause_mode_flat_hint: "Single rule: from X hours → always Y minutes break.",
  pause_mode_tiered: "Tiered rules",
  pause_mode_tiered_hint: "Multiple thresholds, e.g. 5h → 15m, 8h → 30m, 12h → 45m.",
  pause_threshold_hours: "From hours",
  pause_flat_minutes: "Break length (minutes)",
  pause_warning_ratio: "Warn when break is under",
  pause_warning_ratio_hint: "% of shift length — a confirmation popup appears below this.",
  pause_tiers_desc: "Set break minutes per threshold. Highest matching tier wins.",
  pause_tier_from: "From",
  pause_tier_hours: "hours",
  pause_tier_minutes: "min",
  pause_tier_add: "Add rule",
  pause_tier_remove: "Remove",
  pause_tiers_empty: "No rules configured yet.",
  shift_max_length_error: "A shift may not exceed 24 hours.",
  shift_moved: "Shift moved",
  drop_here: "Drop here",
  pause_warning_title: "Are you sure?",
  pause_warning_body: "This shift is {hours} hours but only has {minutes} minutes break. That seems low.",
  pause_warning_confirm: "Yes, save anyway",
  pause_warning_cancel: "Back",
  pause_warning_body_v2: "This shift is {hours}h long but only has {minutes} min of break. That's low compared to your company rule.",
  pause_warning_current_label: "Currently",
  pause_warning_suggested_label: "Suggested",
  pause_warning_cancel_v2: "Edit break",
  pause_warning_confirm_v2: "Save anyway",
  pause_warning_title_v2: "Warn me when break is too low",
  pause_warning_hint_v2: "If someone enters a break far below your company rule, we'll show a popup before saving — so you catch typos and rule breaches.",
  pause_warning_off_label: "Warning off",
  pause_warning_on_label: "Warning on",
  pause_warning_off_hint: "You'll no longer see a confirmation popup for low breaks.",
  pause_warning_slider_label: "Warn when break is under",
  pause_warning_of_shift: "of shift length",
  pause_warning_example_title: "What does this mean?",
  pause_warning_example_body: "Example: on an {ref}h shift, you'll see the popup as soon as the break drops below {min} min.",
  hold_delete_title: "Delete permanently",
  hold_delete_emp_title: "Are you really sure?",
  hold_delete_emp_body: "To avoid accidental clicks: press and hold the red button for 10 seconds. Let go and the timer resets. After 10 seconds the employee is gone — this cannot be undone.",
  hold_delete_press: "Hold for 10 seconds to delete",
  hold_delete_holding: "Holding…",
  hold_delete_done: "Deleted",
  hold_delete_idle_hint: "Releasing resets the timer. Click 'Cancel' to go back.",
  hold_delete_hold_hint: "Let go and the timer starts over.",
  hold_delete_done_hint: "Done — this action cannot be undone.",
  employee_deleted_final: "Employee permanently deleted",
  payroll_export_csv: "Export CSV",
  payroll_export_success: "CSV file downloaded",
  payroll_export_generated_at: "Generated at",
  payroll_export_details_header: "Detail per shift",
  payroll_location_filter: "Filter by location",
  payroll_all_locations: "All locations",
  pause_field_label: "Break (minutes)",
  pause_field_hint: "Leave empty to auto-calculate from your company settings.",
  pause_auto_calculated: "Automatically calculated from your settings.",
  seat_modal_not_owner: "Only the owner can upgrade.",
  handbook: "Handbook",
  handbook_eyebrow: "Rostr documentation",
  handbook_title: "Handbook",
  handbook_role_owner: "Eigenaar",
  handbook_role_manager: "Manager",
  handbook_role_teamlead: "Team lead",
  handbook_role_employee: "Employee",
  handbook_hero_title: "Everything you need to know about your Rostr",
  handbook_hero_desc: "This guide is tailored to your role. Search by keyword or browse the sections below — you'll find every feature, how it works, and when to use it.",
  handbook_search_placeholder: "Search the handbook (e.g. leave, swap, notifications)…",
  handbook_toc: "In this handbook",
  handbook_empty_title: "No results",
  handbook_empty_hint: "Try a different keyword or clear the search.",
  handbook_footer_tip: "Still stuck? Reach out to your company owner, post in the news feed, or email our support team directly:",
  login_extra_eyebrow: "Extra questions",
  login_extra_title: "Any other questions about Rostr?",
  login_extra_desc: "Stuck, curious about a demo, or have an idea to share? Email us — we'll get back to you personally.",
  leave_type: "Leave type", vacation: "Vacation", sick: "Sick",
  personal: "Personal", unpaid: "Unpaid", other: "Other",
  availability_intro: "Set the hours you're available per weekday.",
  availability_saved: "Availability saved",
  monday: "Mon", tuesday: "Tue", wednesday: "Wed", thursday: "Thu",
  friday: "Fri", saturday: "Sat", sunday: "Sun",
  week_of: "Week of", hours: "Hours",
  quick_actions: "Quick actions", recent_activity: "Recent activity",
  broadcast: "Send notification", send: "Send", title: "Title", body: "Body",
  all: "Everyone", by_role: "By role", also_email: "Also email",
  claim_shift: "Claim shift", yes: "Yes", no: "No",
  welcome_back: "Welcome back", upcoming_shifts: "Upcoming shifts",
  request_status: "Request status", swap_shift: "Swap this shift",
  unread: "unread", empty_roster: "No shifts this week.",
  switch_role: "Role", theme: "Theme", open_menu: "Menu", close: "Close",
  company_side: "Admin", employee_side: "Employee",

  greeting_night: "Good night", greeting_morning: "Good morning",
  greeting_afternoon: "Good afternoon", greeting_evening: "Good evening",
  dashboard_subtitle: "Your team at a glance: shifts, leave, swaps and hours waiting for your approval.",
  this_week: "This week", upcoming_shifts_hint: "Upcoming shifts",
  full_roster: "Full schedule", empty_upcoming_shifts: "No upcoming shifts planned yet.",
  activity: "Activity", recent: "Recent", view_all: "All",
  empty_activity: "Nothing here yet.", shift_default: "Shift",
  shifts_today: "Shifts today", open_shifts_7d: "Open shifts (7d)",
  leave_waiting: "Leave waiting", swaps_waiting: "Swaps waiting", hours_waiting: "Hours waiting",
  birthdays: "Birthdays", no_birthdays_week: "No birthdays in the next 7 days.",
  upcoming_label: "Upcoming",
  birthdays_today_count: "today", birthdays_upcoming_count: "this week",

  my_roster_subtitle: "Your shifts, swaps and hours registration in one place.",
  today_work_with: "Today you work with",
  colleague: "colleague", colleagues: "colleagues",
  empty_shifts_week_title: "No shifts this week",
  empty_shifts_week_hint: "Once your manager publishes the schedule, your shifts appear here. You can also claim an open shift above.",

  leave_page_title: "Leave", leave_page_subtitle: "Request time off and follow the status of your requests.",
  days_approved: "Days approved", waiting_decision: "Awaiting decision",
  tab_all: "All", tab_pending: "Pending", tab_approved: "Approved", tab_rejected: "Rejected",
  no_leave_requests: "No leave requests",
  no_leave_hint_all: "Tap 'Request leave' to submit your first request.",
  no_leave_hint_cat: "No requests in this category.",
  choose_dates: "Choose a start and end date",
  from_date: "From", until_date: "Until",
  day_single: "day", day_plural: "days", total_label: "total",
  reason_optional: "Reason (optional)",
  reason_placeholder: "e.g. wedding, family visit, moving house…",
  sick_admin_note_label: "Sick report",
  sick_no_medical_help: "Rostr only records that you are reporting sick and the period. Do not enter a diagnosis, symptoms, cause, treatment or other medical information here — we deliberately do not process this.",
  sending: "Sending…", send_request: "Send request",
  new_request: "New request",
  requested_at: "Requested", decided_at: "Decided",

  swap_page_title: "Swap requests",
  swap_page_subtitle: "Overview of your sent and received shift swaps.",
  tab_sent: "Sent", tab_received: "Received", tab_done: "Done",
  no_swaps_title: "No swap requests in this category",
  no_swaps_hint: "From 'My schedule' tap a shift to request a swap.",
  in_progress_section: "In progress", active_count: "active",
  history_section: "History", done_count: "done",
  everyone_label: "Everyone", you: "You",
  shift_label: "Shift",
  waiting_manager: "Waiting for your manager's approval…",
  cancel_request: "Cancel request",
  created_at: "Created",

  company_label: "Company",
  news_page_title: "News",
  news_page_subtitle: "Announcements, birthdays and updates for the whole team.",
  new_post: "New post",
  news_title_placeholder: "Title — e.g. 'Christmas party next week'",
  news_body_placeholder: "What do you want to share with your team?",
  pin_top: "Pin to top",
  posting: "Posting…", post: "Post",
  title_body_required: "Title and body are required",
  post_published: "Post published",
  delete_post_confirm: "Delete this post?",
  deleted: "Deleted",
  birthday_today_title: "Birthday today",
  congratulate: "Congratulate your colleague!",
  pinned_label: "Pinned",
  birthdays_month_title: "Birthdays this month",
  birthdays_month_hint: "Upcoming team birthdays",
  no_news_title: "No news yet",
  no_news_hint_manager: "Post the first message to keep your team in the loop.",
  no_news_hint_employee: "As soon as there's news, it will appear here.",
  news_empty_dismissed_title: "Inbox empty",
  news_empty_dismissed_hint: "You've swiped everything away. New posts will show up here as soon as they're published.",
  news_restore_all: "Restore hidden posts",
  news_restore_hidden_prefix: "Show",
  news_restore_hidden_one: "hidden post again",
  news_restore_hidden_many: "hidden posts again",
  news_restored: "Posts restored",
  news_swipe_hint: "Tip: swipe a post left to hide it just for you.",

  back: "Back",
  preferences_label: "Notifications",
  preferences_subtitle: "Choose per update type which channel delivers the notification.",
  how_notifs_work: "How notifications work",
  how_notifs_explain: "Choose per update type which channel receives the notification. Multiple channels can be on at once, or you can turn off a category entirely.",
  channel_app_hint: "appears in the bell icon at the top right when Rostr is open.",
  channel_email_hint: "sent to the address on your profile. Handy if Rostr isn't often open.",
  channel_push_hint: "pop-up on your phone or laptop, even if Rostr isn't active. Turn it on below.",
  push_on_device: "Push on this device",
  push_active: "Active. Test with the button below.",
  active: "Active",
  inactive: "Inactive",
  pause_disabled_note: "Shifts get no automatic break",
  pause_save_hint: "Changes only apply after Save.",
  pause_tiers_count: "rules",
  pause_preview_title_v2: "Here's how your break rule works",
  pause_preview_subtitle: "Live preview — updates as you tweak",
  pause_try_it: "Try it out",
  pause_try_hint: "Drag the duration ↓",
  pause_hours_worked: "hours scheduled",
  pause_label: "Break",
  pause_explain_title: "How does it work?",
  pause_explain_body: "Rostr subtracts the break automatically as soon as someone works longer than the threshold. Employees see net hours; you see the gross roster.",
  pause_reference_examples: "Examples",
  dashboard_row_kpis: "Key stats",
  dashboard_row_details: "Details & insights",
  quick_add_desc: "Add quickly without leaving the page",
  qa_desc_employee: "Send an invitation to a new employee",
  qa_desc_location: "Add a new location to your organisation",
  qa_desc_team: "Create a new team to group employees",
  qa_desc_broadcast: "Send everyone in the organisation a message",
  location_created: "Location added",
  team_created: "Team added",
  broadcast_sent: "Message sent",
  broadcast_title_ph: "Subject",
  broadcast_body_ph: "What do you want everyone to know?",
  field_required: "Fill in all fields",
  swap_subtitle: "Review all shift swaps in one place",
  swap_filter_actionable: "Needs action",
  swap_filter_all: "All",
  swap_filter_pending: "Pending",
  swap_filter_accepted: "Ready to approve",
  swap_filter_approved: "Approved",
  swap_filter_rejected: "Rejected",
  swap_empty_title: "No swap requests",
  swap_empty_actionable: "Nothing is waiting for your approval.",
  swap_empty_hint: "Once your team wants to swap shifts, they'll appear here.",
  swap_awaiting_target: "Waiting for colleague to respond",
  swap_ready_for_approval: "Both employees agreed — your approval needed",
  push_allow: "Allow pop-ups so push works.",
  on: "On", off: "Off",
  test_notification: "Test notification",
  notification_types: "Notification types",
  pref_categories: "categories on",
  phone_on: "Phone on", phone_off: "Phone off",
  notifs_off_toast: "Notifications turned off", notifs_on_toast: "Notifications on",
  action_failed: "Action failed",
  test_sent: "Test notification sent", test_failed: "Test failed",
  couldnt_save: "Could not save",
  cat_leave_desc: "When your manager approves or rejects your request",
  cat_swap_desc: "When a colleague asks you to swap a shift — or your proposal gets a reply",
  cat_news_desc: "Announcements from your manager or HR in the news feed",
  cat_birthday_desc: "When a colleague has a birthday, so you can congratulate them",
  cat_roster_desc: "When your manager publishes a new week or changes your shift",
  cat_leave: "Leave", cat_swap: "Swap requests", cat_news: "News",
  cat_birthday: "Birthdays", cat_roster: "Schedule",
  appearance: "Appearance", light: "Light", dark: "Dark",
  light_desc: "Classic and bright", dark_desc: "Easy on the eyes",
  language_label: "Language",
  lang_set: "Language",
  channel_app: "App", channel_email: "Email", channel_push: "Push",

  new_badge: "New · workforce scheduling",
  hero_line1: "Workforce planning",
  hero_line2: "without the hassle.",
  hero_desc: "Plan shifts, manage leave and keep hours and teams organised in one place.",
  create_company_cta: "Create company",
  have_invite_cta: "I have an invite code",
  trust_30_days: "Free trial",
  trust_invites: "Invite codes",
  trust_langs: "2 languages",
  trust_mobile: "Mobile-friendly",
  of_with_email: "or with email",
  all_in_one: "All-in-one",
  from_roster_to_pay: "From scheduling chaos to calm.",
  everything_you_need: "Everything you need to plan your team — and nothing more.",
  hl_smart_roster: "Smart schedule",
  hl_smart_roster_desc: "Drag shifts, plan per week or day, and publish to your team with one click.",
  hl_leave: "Paperless leave",
  hl_leave_desc: "Employees request, you approve. Notifications by email and in-app.",
  hl_swaps: "Shift swaps",
  hl_swaps_desc: "Colleagues swap among each other — with or without manager approval.",
  hl_hours: "Time tracking",
  hl_hours_desc: "Log and approve actual start and end times.",
  hl_roles: "3 roles, one workplace",
  hl_roles_desc: "Manager, Team lead and Employee — with exactly the right permissions.",
  hl_notifs: "Instant notifications",
  hl_notifs_desc: "Schedule published, leave decided or swap proposed — everyone knows instantly.",
  pricing: "Pricing",
  try_30_days: "Try it stress-free.",
  pricing_desc: "No credit card required. Test with your whole team. Then one simple subscription per company — only the Owner pays.",
  start_now: "Start now", more_questions: "More questions?",
  faq: "FAQ", faq_title: "Short and sweet.",
  faq_q1: "Who can create a company?",
  faq_a1: "Anyone. Whoever creates the company automatically becomes Owner and manages members and settings.",
  faq_q2: "How do employees join?",
  faq_a2: "You generate a unique invite code per role. Employees enter it at 'I have an invite code' or use the link from their email.",
  faq_q3: "Does Google sign-in work?",
  faq_a3: "Yes. The login, signup and join pages all have 'Sign in with Google'. No password needed.",
  faq_q4: "Can I manage multiple locations?",
  faq_a4: "Yes. Locations, teams and roles are unlimited within your company.",
  faq_q5: "Does it work on mobile?",
  faq_a5: "Yes. The app is fully responsive with a dedicated bottom nav for employees on their phone.",
  nav_features: "Features", nav_pricing: "Pricing", nav_faq: "FAQ",
  footer_privacy: "Privacy", footer_terms: "Terms", footer_support: "Support",
  footer_tagline: "workforce scheduling",
  // Fase 6.2 — Product value section on public landing
  landing_product_eyebrow: "What you do with Rostr",
  landing_product_title: "Everything for your workforce planning in one place.",
  landing_product_desc: "Six clear building blocks — no marketing puff, just the functionality that exists.",
  pv_roster_title: "Roster",
  pv_roster_desc: "Plan shifts per week or day, per location or team, and publish when you're ready.",
  pv_leave_title: "Leave",
  pv_leave_desc: "Request, approve or reject — with insight into who's off and when.",
  pv_hours_title: "Hours",
  pv_hours_desc: "Log actual start and end times, review and approve them.",
  pv_employees_title: "Employees",
  pv_employees_desc: "Team, contract, contact details and permissions managed per employee.",
  pv_reports_title: "Reports",
  pv_reports_desc: "Live overviews and CSV exports for roster, leave and hours.",
  pv_locations_title: "Multiple locations",
  pv_locations_desc: "Keep branches, teams and roles separate — without running separate environments.",
  landing_stat_roles: "Roles",
  landing_stat_trial: "Free trial",
  landing_stat_langs: "Languages",
  google_login: "Sign in with Google",
  google_create_company: "Create company with Google",
  google_continue: "Continue with Google",

  step_of: "Step {n} of 2",
  tell_company: "Tell us about your company",
  your_account: "Now your account",
  company_data_help: "We'll add this to your company settings. You can change it later.",
  owner_note: "You become the Owner of this company — you manage employees and settings.",
  company_name: "Company name",
  industry: "Industry", size: "Size", country: "Country",
  size_employees: "employees",
  first_name: "First name", last_name: "Last name",
  fastest_option: "Fastest option — no password needed",
  or_email_password: "or with email + password",
  email_addr: "Email address",
  min_6_chars: "Min. 6 characters",
  working: "Working...",
  create_company: "Create company",
  already_account: "Already have an account? Sign in",
  no_credit_card: "No credit card required",
  welcome_company: "Welcome to Rostr",

  join_company_title: "Join a company",
  fill_invite: "Enter your invite code",
  create_account: "Create your account",
  invitation_code: "Invite code",
  invalid_code: "Invalid code",
  checking: "Checking...",
  verify_code: "Verify code",
  invited_by: "invited by",
  birthday_field: "Date of birth",
  joining: "Joining",
  welcome_team: "Welcome to the team",

  search_placeholder: "Search...",
  invite_code_btn: "Invite code",
  job_function: "Position", department_col: "Department", birthday_col: "Birthday",
  job_placeholder: "e.g. Barista, Nurse",
  dept_placeholder: "e.g. Sales, Kitchen, IT",
  code_copied: "Code {code} copied (role: {role})",
  code_error: "Could not create code",
  close_label: "Close",

  no_notifs_title: "No notifications yet",
  no_notifs_hint: "You'll get notifications here about new shifts, leave decisions and swap requests.",
  target: "Target",

  profile_subtitle: "Manage your details and preferences.",
  my_overview_section: "My overview",
  my_overview_nav: "My overview",
  my_overview_eyebrow: "My overview",
  my_overview_title: "My overview",
  my_overview_subtitle: "Your leave, expected pay and colleagues' birthdays — all in one place.",
  view_day: "Day",
  view_week: "Week",
  approved: "Approved",
  remaining: "Left",
  year: "Year",
  days: "days",
  day_free: "No shift — day off",
  day_free_past: "Day off",
  no_pause: "No break",
  shift_singular: "shift",
  my_details: "Details",
  birthday_privacy_hint: "Your colleagues see the day/month, the year stays private.",
  session: "Session",
  logout_device: "Sign out on this device.",
  preferences_desc: "Push, email and in-app notifications per update type.",

  roster_subtitle: "Plan shifts, assign employees and publish per week.",
  all_locations: "All locations", filter: "Filter",
  empty_roster_hint: "Click '+' in a day or use 'Add shift' to schedule your first shift.",
  edit_shift: "Edit shift",
  shift_role_placeholder: "Cook, service, support...",
  copy_prev_week: "Copy previous week",
  copy_prev_week_hint: "Duplicate all shifts from last week to this week (draft)",
  copied_shifts: "shifts copied",
  total_hours: "Total hours",
  hours_per_employee: "Hours per employee",
  planned: "planned",
  copy_menu: "Copy",
  copy_to_next_week: "Copy to next week",
  copy_to_next_week_hint: "Duplicate this week to next week as draft",
  copy_pick_days: "Pick days…",
  copy_pick_days_hint: "Copy one or more days to specific target days",
  copy_days_title: "Copy days",
  copy_days_h: "Pick source and target days",
  copy_days_hint: "Select which days of this week to copy and where. All shifts from selected source days will be created as draft on every target day.",
  copy_step_source: "Which days to copy?",
  copy_step_target: "To which days?",
  copy_pick_both: "Pick both source and target days",
  copy_keep_employee: "Keep assigned employees",
  copy_keep_employee_hint: "Off = target days become unassigned",
  copy_now: "Copy now",
  copying: "Copying…",
  shifts_will_be_created: "shifts will be created",
  shifts_short: "sh.",
  no_shifts_yet: "No shifts scheduled for this day",
  shift_singular: "shift",
  shifts: "shifts",
  shifts_selected: "shifts",
  select_week: "Whole week",
  duplicate_shift: "Duplicate +1 day",
  duplicate_shift_hint: "Create a copy on the next day",
  shift_duplicated: "Shift duplicated to next day",
  view_by_day: "By day",
  view_by_employee: "By employee",
  // Mobile roster (Manager / Team Lead)
  mroster_selected_day: "Selected day",
  mroster_tab_shifts: "Shifts",
  mroster_tab_team: "Team",
  mroster_off_today: "Off today",
  mroster_unassigned_single: "1 shift is not yet assigned to an employee",
  mroster_unassigned_multi: "{n} shifts are not yet assigned",
  mroster_team_summary: "{working} of {total} employees working today",
  mroster_empty_hint: "Tap the + button to add a shift for this day.",
  no_employees_yet: "No employees yet",
  // Shift overlap
  shift_overlap_title: "Shift overlaps with existing shift",
  shift_overlap_desc: "This employee already has a shift in this time range on this day. Pick a different time or edit the existing shift.",
  existing_shift: "Existing shift",
  conflict_understood: "Got it",
  copy_partial_title: "Some shifts were skipped",
  copy_partial_desc: "The following shifts conflicted with existing shifts and were skipped:",
  copy_partial_created: "copied",
  copy_partial_skipped: "skipped due to overlap",
  contact_info: "Contact details",
  no_upcoming_shifts: "No upcoming shifts",
  no_upcoming_shifts_hint: "This employee has no shifts scheduled in the next 60 days.",
  emp_tab_overview: "Overview",
  emp_tab_leave: "Leave",
  emp_tab_swap: "Swaps",
  emp_no_leave_title: "No leave requests",
  emp_no_leave_hint: "This employee hasn't requested any leave yet.",
  emp_no_swap_title: "No swap requests",
  emp_no_swap_hint: "This employee has no shift swaps yet.",
  emp_swap_from: "Requester",
  emp_swap_to: "Recipient",

  // Welcome intro
  welcome_hello: "Hello",
  welcome_there: "there",
  welcome_tagline: "Schedule · team · calm",
  welcome_intro_desc: "Good to see you again. Here's a quick look at what's waiting.",
  welcome_summary_eyebrow: "What's waiting for you",
  welcome_summary_title: "Ready to jump in?",
  welcome_summary_empty: "All caught up",
  welcome_summary_empty_desc: "Nothing urgent right now. Have a great day!",
  welcome_next: "Next",
  welcome_start: "Go to dashboard",
  welcome_skip: "Skip",
  welcome_unread_notifications: "{n} unread notifications",
  welcome_pending_leave: "{n} leave requests to review",
  welcome_pending_swaps: "{n} swap requests to review",
  welcome_pending_time: "{n} timesheets to approve",
  welcome_open_shifts: "{n} open shifts",
  welcome_shifts_this_week: "{n} shifts this week",
  welcome_my_shifts_today: "{n} shifts today",
  welcome_my_shifts_week: "{n} shifts this week",
  welcome_pending_own_leave: "{n} of your leave requests pending",
  welcome_claimable_shifts: "{n} open shifts you can claim",

  // Customizable dashboard widgets
  customize_dashboard: "Customize",
  widget_picker_title: "Choose your widgets",
  widget_picker_subtitle: "Turn on what you want to see on your dashboard. Max 20.",
  widget_reset: "Reset defaults",
  dashboard_empty_title: "Pick your first widgets",
  dashboard_empty_desc: "Personalize your dashboard with the info that matters to you.",
  widget_cat_stats: "Core stats",
  widget_cat_personal: "My work",
  widget_cat_team: "Team",
  widget_cat_planning: "Planning",
  widget_cat_requests: "Requests",
  widget_cat_updates: "Updates",
  widget_cat_actions: "Quick actions",
  w_stat_employees: "Employees",
  w_stat_employees_desc: "Total employees in your company.",
  w_stat_shifts_week: "Shifts this week",
  w_stat_shifts_week_desc: "All shifts scheduled for the next 7 days.",
  w_stat_open_shifts: "Open shifts",
  w_stat_open_shifts_desc: "Shifts without an assigned employee.",
  w_stat_pending_leave: "Leave pending",
  w_stat_pending_leave_desc: "Leave requests waiting for your approval.",
  w_stat_pending_swaps: "Swaps pending",
  w_stat_pending_swaps_desc: "Swap requests waiting for a decision.",
  w_stat_pending_time: "Hours pending",
  w_stat_pending_time_desc: "Timesheets awaiting approval.",
  w_stat_locations: "Locations",
  w_stat_locations_desc: "Number of locations.",
  w_stat_teams: "Teams",
  w_stat_teams_desc: "Number of teams in your company.",
  w_stat_total_hours: "Total hours this week",
  w_stat_total_hours_desc: "All scheduled hours for this week.",
  w_my_shifts: "My shifts",
  w_my_shifts_desc: "Your own upcoming shifts.",
  w_team_today: "Team today",
  w_team_today_desc: "Who is working today and at what times.",
  w_recent_activity: "Recent activity",
  w_recent_activity_desc: "Latest notifications and updates.",
  w_recent_news: "Recent news",
  w_recent_news_desc: "Latest posts from your team.",
  w_upcoming_birthdays: "Birthdays",
  w_upcoming_birthdays_desc: "Who has a birthday this week.",
  w_pending_leave_list: "Leave requests",
  w_pending_leave_list_desc: "List of open leave requests.",
  w_open_shifts_list: "Open shifts",
  w_open_shifts_list_desc: "Unassigned shifts for the coming week.",
  w_top_hours: "Top hours per employee",
  w_top_hours_desc: "Who works the most this week.",
  w_quick_actions: "Quick actions",
  w_quick_actions_desc: "Quickly add a shift, employee or location.",
  w_week_calendar: "Week calendar",
  w_week_calendar_desc: "Mini calendar with all shifts this week.",
  w_hours_bar: "Hours per day",
  w_hours_bar_desc: "Bar chart of scheduled hours per weekday.",
  // Manager-specific widgets
  w_urgent_open: "Urgent open shifts",
  w_urgent_open_desc: "Open shifts in the next 48 hours — red under 24h.",
  w_publish_status: "Publish status",
  w_publish_status_desc: "Percentage of published shifts per day this week.",
  w_roster_horizon: "Roster horizon",
  w_roster_horizon_desc: "How many days ahead the roster is scheduled.",
  w_leave_taken_ytd: "Leave taken this year",
  w_leave_taken_ytd_desc: "Top 5 employees with most leave this year.",
  w_broadcast_composer: "Send broadcast",
  w_broadcast_composer_desc: "Send a message to everyone or by role from your dashboard.",
  days_short: "d",
  field_locked_badge: "Locked",
  field_locked_hint: "Only your manager or team lead can change this. Ask them to update your details.",
  // Manager online hint
  manager_online_hint_title: "More features are available online",
  manager_online_hint_body: "Building rosters, approving leave, managing employees and downloading reports lives in your account on the website.",
  // Birthday celebrate reaction
  celebrate: "Celebrate",
  celebrated: "You joined the party",
  celebrated_hint: "Message sent to the birthday person",
  // Shift notes
  shift_notes: "Notes",
  shift_notes_placeholder: "e.g. Please also organise the fridge, prep for lunch peak 12–14...",
  shift_notes_hint: "Visible to the employee on their shift.",
  // Claim warning
  warning: "Warning",
  claim_warning_title: "Are you sure you want to take this shift?",
  claim_warning_reason: "This shift is for a different role than yours! Taking it may mean handling tasks outside your usual function.",
  claim_warning_hint: "Not sure? Check with your manager or team lead before taking this shift.",
  claim_warning_confirm: "Yes, take it anyway",
  shift_role: "Shift role",
  your_role: "Your role",
  reason: "Reason",

  // Sidebar sections
  navsec_planning: "Planning",
  navsec_team: "Team",
  navsec_requests: "Requests",
  navsec_insights: "Insights & updates",
  navsec_system: "System",
  navsec_my_work: "My work",
  navsec_updates: "Updates & account",
  // Phase 9B.2 — role-specific navigation
  navsec_time_absence: "Time & absence",
  navsec_insights_v2: "Insights",
  navsec_communication: "Communication",
  navsec_admin: "Administration",
  navsec_day_ops: "Day operations",
  navsec_account: "Account",
  more_nav: "More",
  home: "Home",
  manager_side: "Admin",
  team_today_title: "Team today",
  quick_assign_title: "Quick assign",

  admin_label: "Admin",
  settings_owner_desc: "Manage your company data, privacy and invitations.",
  settings_readonly: "Only the owner can change settings.",
  company_data: "Company data",
  company_data_desc: "Name, sector and timezone as shown in the app.",
  sector: "Sector", timezone_label: "Timezone",
  default_language: "Default language", team_size: "Team size",
  saving: "Saving…",
  company_saved: "Company data saved",
  settings_saved: "Settings saved",
  privacy_label: "Privacy",
  privacy_desc: "Decide what employees see about each other in the directory.",
  show_phone: "Show phone", show_email: "Show email",
  show_dept: "Show department", show_title: "Show job title",
  show_birthday: "Show birthday",
  show_birthday_hint: "Employees see day/month when on",
  hide_birthyear: "Hide birth year",
  hide_birthyear_hint: "Recommended: show only day/month — age stays private",
  invitations: "Invitations",
  invitations_desc: "Who can invite employees and how long codes are valid.",
  managers_invite: "Managers may invite",
  teamleads_invite: "Team leads may invite",
  codes_expire: "Codes expire after (days)",
  save_privacy_invitations: "Save privacy & invitations",

  desktop_only_title: "Sorry, this only works on the website.",
  desktop_only_manager: "Building schedules, managing employees and approving requests is done on your computer or tablet. That way you really keep oversight.",
  desktop_only_employee: "This page is only available on desktop.",
  view_notifications: "View notifications",
  go_to_profile: "Go to profile",
  desktop_tip: "Tip: open Rostr in a browser on your laptop, or use desktop mode in your mobile browser.",

  google_linking: "Linking Google account…",
  google_wait: "One moment while we set up your account.",
  login_failed: "Sign-in failed",
  no_session: "No session received from Google.",
  back_to_login: "Back to login",
  company_created_toast: "Company {name} created",
  logged_in_google: "Signed in with Google",

  // ---------- Payroll (manager + owner) ----------
  payroll_label: "Payroll",
  // ---------- Header additions (Feb 2026) ----------
  search: "Search",
  cmdk_placeholder: "Search pages, people, shifts…",
  cmdk_coming_soon: "Global search — coming soon ✨",
  cmdk_section_pages: "Pages",
  cmdk_section_actions: "Actions",
  cmdk_section_people: "People",
  cmdk_empty: "No results",
  cmdk_hint_navigate: "navigate",
  cmdk_hint_open: "open",
  cmdk_hint_results: "results",
  cmdk_action_new_shift: "New shift",
  cmdk_action_quick_assign: "Quick assign",
  cmdk_action_whats_new: "What's new",
  cmdk_action_toggle_theme: "Toggle dark/light",
  swipe_hint: "Swipe right to approve, left to reject",
  offline_banner: "You are offline — showing last loaded data",
  whats_new: "What's new?",
  // ---------- Dashboard sections (Feb 2026) ----------
  section_overview: "Overview",
  section_personal: "Personal",
  section_planning: "Planning",
  section_team: "Team",
  section_requests: "Requests",
  section_updates: "Updates",
  section_actions: "Actions",
  // ---------- Widget titles (Fase 1 — Feb 2026) ----------
  w_my_leave_balance: "My leave balance",
  w_my_leave_balance_desc: "Vacation days — remaining, approved and pending this year.",
  w_my_expected_pay: "Expected pay",
  w_my_expected_pay_desc: "What you'll roughly earn this month based on scheduled shifts.",
  w_birthdays_this_week: "Birthdays this week",
  w_birthdays_this_week_desc: "Colleagues with a birthday this week.",
  w_hours_vs_contract: "Hours vs contract",
  w_hours_vs_contract_desc: "Who's above, on, or below contract hours this week.",
  hvc_over: "above contract",
  hvc_under: "below contract",
  planned_hours_short: "planned",
  pending: "Pending",
  payroll_page_title: "Payroll overview",
  payroll_page_subtitle: "Hourly rates, weekend multipliers and totals per employee — all in one view.",
  payroll_period_week: "By week",
  payroll_period_month: "By month",
  payroll_this_week: "This week",
  payroll_this_month: "This month",
  payroll_prev_period: "Previous period",
  payroll_next_period: "Next period",
  payroll_grand_total: "Total to pay",
  payroll_total_hours: "Net hours",
  payroll_hours_short: "h",
  payroll_no_rate: "No hourly rate set",
  payroll_no_rate_short: "No rate yet",
  payroll_hourly_rate: "Hourly rate",
  payroll_effective_rate: "Effective",
  payroll_multiplier: "Multiplier",
  payroll_shifts_count: "{n} shifts",
  payroll_col_shifts: "Shifts",
  payroll_no_shifts: "No shifts in this period",
  payroll_view_details: "Details",
  payroll_hide_details: "Hide details",
  payroll_settings_title: "Day-of-week multipliers",
  payroll_settings_desc: "Applies to every employee — unless they have a personal override.",
  payroll_settings_save: "Save multipliers",
  payroll_settings_saved: "Multipliers saved",
  payroll_rate_modal_title: "Hourly rate for {name}",
  payroll_rate_field_label: "Hourly rate (€/h)",
  payroll_rate_placeholder: "e.g. 14.50",
  payroll_rate_override_toggle: "Set personal multipliers (overrides company defaults)",
  payroll_rate_override_help: "Leave a day empty to use the company multiplier.",
  payroll_rate_clear_override: "Clear overrides",
  payroll_rate_saved: "Hourly rate saved",
  payroll_edit_rate: "Edit rate",
  payroll_print: "Print overview",
  payroll_no_data_title: "No payroll data yet",
  payroll_no_data_hint: "Set an hourly rate per employee — multipliers and totals will fill in automatically.",
  payroll_gross_hours: "Gross",
  payroll_pause: "Break",
  payroll_net: "Net",
  payroll_amount: "Amount",
  payroll_period_label: "Period",
  payroll_print_footer: "Generated on {when} · Rostr Payroll",
  dow_mon: "Mon", dow_tue: "Tue", dow_wed: "Wed", dow_thu: "Thu",
  dow_fri: "Fri", dow_sat: "Sat", dow_sun: "Sun",
  dow_mon_full: "Monday", dow_tue_full: "Tuesday", dow_wed_full: "Wednesday",

  // Fase 5 — Settings / Profile / Weergave
  industry_hospitality: "Hospitality",
  industry_retail: "Retail",
  industry_healthcare: "Healthcare",
  industry_office: "Office",
  industry_logistics: "Logistics",
  industry_other: "Other",
  industry_other_label: "Own industry",
  industry_other_placeholder: "e.g. Security, Education…",
  localisation: "Localisation",
  localisation_desc: "Country, timezone and language of the company.",
  country_search_placeholder: "Search by name or ISO code…",
  employees_and_plan: "Employees & plan",
  employees_and_plan_desc: "Seats currently used. The maximum comes from your plan — not from this page.",
  seat_count: "Seats used",
  seats_available: "seats free",
  seats_unlimited: "Unlimited",
  company_size_label: "Company size (informational)",
  company_size_hint: "Metadata only — does not set a limit.",
  theme_light: "Light",
  theme_dark: "Dark",
  theme_system: "System",
  codes_expire_hint: "After this window an unclaimed code stops working. Claimed accounts stay active.",
  personal_settings: "Personal preferences",
  personal_settings_desc: "Theme, language and notifications live on your profile page.",
  personal_settings_link_hint: "Open your profile to change language and theme.",

  notif_target_missing: "The linked request no longer exists.",
  notif_target_error: "Could not open the action.",
  close: "Close",
  // Fase 6 — GDPR / privacy & data
  privacy_and_data: "Privacy & data",
  privacy_and_data_desc: "Export your own data or delete your account. Company actions are owner-only.",
  download_my_data: "Download my data",
  download_my_data_desc: "ZIP with JSON files of your profile, rosters, leave, swaps and notifications.",
  delete_account: "Delete account",
  delete_account_desc: "Personal data is anonymised. Historical company records are preserved.",
  export_company: "Export company data",
  export_company_desc: "ZIP with company config, users, rosters and 12 months of audit log.",
  delete_company: "Delete company",
  delete_company_desc: "Schedule deletion with a 30-day grace period. Owner-only.",
  danger_zone: "Danger zone",
  grace_period_info: "After confirming, Rostr is unavailable for 30 days. You can cancel within that period.",
  type_company_name_to_confirm: "Type the company name to confirm",
  current_password: "Current password",
  confirm_delete: "Delete permanently",
  err_reauth_required: "Enter your password to confirm.",
  err_invalid_password: "Wrong password.",
  err_owner_delete_blocked: "You are the only owner — delete the company first.",
  err_company_delete_confirmation_invalid: "The company name does not match.",
  err_company_deletion_pending: "A deletion is already scheduled.",
  err_export_rate_limited: "Too many exports. Try again in an hour.",
  err_tenant_inactive: "This company is paused because a deletion is scheduled.",
  account_deleted_ok: "Your account has been deleted.",
  company_deletion_scheduled: "Company deletion scheduled for {date}. You can cancel within 30 days.",
  cancel_company_deletion: "Cancel deletion",
  company_deletion_cancelled: "Deletion cancelled.",
  deleted_employee: "Deleted employee",
  legal_privacy: "Privacy policy",
  legal_terms: "Terms",
  legal_draft_banner: "Draft version — this text will be legally reviewed before commercial launch.",
  legal_last_updated_label: "Last updated",
  legal_last_updated_value: "August 2026",
  legal_toc_title: "Contents",
  legal_back_home: "Back to Rostr",
  legal_lang_switch: "Switch language",
  legal_review_note: "Legal review required",
  // Fase 4.1 — Leave (management) + Reports live stats
  lr_page_title: "Leave overview",
  lr_page_subtitle: "Review your team's leave requests, split by status.",
  lr_tab_pending: "Pending",
  lr_tab_approved: "Approved",
  lr_tab_rejected: "Rejected",
  lr_tab_history: "History",
  lr_empty_pending: "No pending requests.",
  lr_empty_approved: "No approved requests in this list.",
  lr_empty_rejected: "No rejected requests.",
  lr_empty_history: "No historical requests yet.",
  lr_col_employee: "Employee",
  lr_col_type: "Type",
  lr_col_period: "Period",
  lr_col_days: "Days",
  lr_col_status: "Status",
  lr_col_location: "Location",
  lr_col_team: "Team",
  lr_action_approve: "Approve",
  lr_action_reject: "Reject",
  // Fase 6.5A — sick decide-modal UX. Short administrative note with a hard
  // 250-char cap and an explicit warning that medical content must NOT go
  // in here. The backend enforces the same cap (canonical).
  lr_sick_note_label: "Administrative note",
  lr_sick_note_help: "Do not enter a diagnosis, symptoms, cause, treatment, medication or other medical information.",
  lr_sick_note_counter: "{count}/250",
  lr_sick_note_optional_placeholder: "For example: follow-up via HR scheduled.",
  lr_note_optional_label: "Note (optional)",
  lr_confirm_approve: "Approve",
  lr_confirm_reject: "Reject",
  lr_confirm_cancel: "Cancel",
  lr_modal_title_approve_sick: "Approve sick report",
  lr_modal_title_reject_sick: "Reject sick report",
  lr_modal_title_approve: "Approve request",
  lr_modal_title_reject: "Reject request",
  rep_stats_title: "Live statistics",
  rep_stats_desc: "Follows the active filters exactly — period, employee, team, location, type and status.",
  rep_stat_total: "Requests",
  rep_stat_approved: "Approved",
  rep_stat_rejected: "Rejected",
  rep_stat_pending: "Pending",
  rep_stat_sick_reports: "Sick reports",
  rep_stat_sick_employees: "Sick employees",
  rep_stat_sick_days: "Sick days",
  rep_results_title: "Results",
  rep_results_desc: "All requests inside the active filters. Days = only days inside the chosen period.",
  rep_results_empty: "No results for these filters.",
  rep_results_error: "Could not load the report. Please retry.",
  rep_loading: "Loading…",
  rep_filter_type: "Leave type",
  rep_filter_status: "Status",
  rep_filter_employee: "Employee",
  rep_leave_title: "Leave & absence",
  rep_leave_desc: "Reporting on leave and absence within the chosen period.",
  rep_col_employee: "Employee",
  rep_col_type: "Type",
  rep_col_period: "Period",
  rep_col_days_in_period: "Days in period",
  rep_col_status: "Status",
  rep_col_team: "Team",
  rep_col_location: "Location",
  status_pending: "Pending",
  status_approved: "Approved",
  status_rejected: "Rejected",

  dow_thu_full: "Thursday", dow_fri_full: "Friday", dow_sat_full: "Saturday", dow_sun_full: "Sunday",
};


export function translate(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.en[key] || dict.nl[key] || key;
}

export default dict;
